import React, { useState, useRef, Children, Component, useEffect, createContext } from 'react';
import { css, cx } from 'emotion';
import PropTypes from 'prop-types';
import { createCustomClassNames as createCustomClassNames$1, combineEventHandlers as combineEventHandlers$1 } from '@weave-design/utils';
import Flyout$1, { AVAILABLE_TRANSITION_STATUSES as AVAILABLE_TRANSITION_STATUSES$1, transitionStatuses as transitionStatuses$1, Panel as Panel$1, anchorPoints as anchorPoints$1, AVAILABLE_ANCHOR_POINTS as AVAILABLE_ANCHOR_POINTS$1 } from '@weave-design/flyout';
import Typography from '@weave-design/typography';
import IconButton from '@weave-design/icon-button';
import { Notification16, Notification24, CloseSUI } from '@weave-design/icons';
import ThemeContext from '@weave-design/theme-context';
import { ControlBehavior } from '@weave-design/behaviors';
import Transition, { UNMOUNTED, EXITED, ENTERING, ENTERED, EXITING } from 'react-transition-group/Transition';
import RichText from '@weave-design/rich-text';
import ProgressRing from '@weave-design/progress-ring';

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const types = Object.freeze({
  ERROR: "error",
  PRIMARY: "primary",
  SUCCESS: "success",
  WARNING: "warning"
});
const AVAILABLE_TYPES = Object.freeze(Object.values(types));

function getRulesByTransitionStatus(transitionStatus) {
  if (transitionStatus === "exiting") {
    return {
      height: 0,
      opacity: 0
    };
  }

  if (transitionStatus === "exited") {
    return {
      display: "none"
    };
  }

  return {};
}

function getRulesByType(type, themeData) {
  switch (type) {
    case types.ERROR:
      return {
        borderLeftColor: themeData["colorScheme.status.error"]
      };

    case types.WARNING:
      return {
        borderLeftColor: themeData["colorScheme.status.warning"]
      };

    case types.SUCCESS:
      return {
        borderLeftColor: themeData["colorScheme.status.success"]
      };

    default:
      return {
        borderLeftColor: themeData["basics.colors.primary.autodeskBlue.500"]
      };
  }
}

function stylesheet$1(props, themeData) {
  const {
    hasHover,
    loadingTransitionState,
    showCount,
    stylesheet: customStylesheet,
    transitionStatus,
    type,
    unread
  } = props;
  const isEntering = loadingTransitionState === `entering` || loadingTransitionState === `entered`;
  const styles = {
    dismissButton: _objectSpread2$1({
      display: `none`,
      position: `absolute`,
      top: 0,
      right: 0
    }, hasHover ? {
      display: `block`
    } : {}),
    notification: _objectSpread2$1(_objectSpread2$1({
      position: `relative`,
      overflow: `hidden`,
      transitionProperty: `height, opacity`,
      transitionDuration: `300ms`,
      transitionTimingFunction: `ease`,
      "&:last-child": {
        borderBottom: `none`
      }
    }, transitionStatus ? getRulesByTransitionStatus(transitionStatus) : {}), hasHover ? {
      backgroundColor: themeData["colorScheme.surface.level300"]
    } : {}),
    notificationContent: _objectSpread2$1({
      display: `flex`,
      borderBottom: `1px solid ${themeData["divider.heavyColor"]}`,
      borderLeft: `3px solid #bec8d2`
    }, unread ? getRulesByType(type, themeData) : {
      borderLeftColor: `rgba(128, 128, 128, 0.4)`
    }),
    notificationContentImage: {
      margin: `${themeData["density.spacings.small"]} 0 ${themeData["density.spacings.small"]} ${themeData["density.spacings.small"]}`
    },
    notificationContentText: {
      margin: `${themeData["density.spacings.small"]}`,
      wordWrap: `break-word`,
      overflow: `hidden`
    },
    panelTitle: {
      padding: `${themeData["density.spacings.small"]}
        ${themeData["density.spacings.large"]}`,
      borderBottom: `1px solid ${themeData["divider.heavyColor"]}`
    },
    panelContainer: {
      width: `300px`,
      overflowY: `auto`,
      overflowX: `hidden`
    },
    panelLoading: _objectSpread2$1({
      display: `flex`,
      boxSizing: `border-box`,
      justifyContent: `center`,
      alignItems: `center`,
      height: 0,
      overflow: `hidden`,
      backgroundColor: `transparent`,
      opacity: `0`,
      transitionProperty: `height, opacity`,
      transitionDuration: `300ms`,
      transitionTimingFunction: `ease`,
      pointerEvents: `none`
    }, isEntering ? {
      height: `44px`,
      opacity: 1
    } : {}),
    indicator: {
      display: `flex`,
      position: `relative`
    },
    indicatorCount: _objectSpread2$1({
      position: `absolute`,
      top: `50%`,
      left: `50%`,
      height: `13px`,
      padding: `0 3px`,
      fontSize: `11px`,
      lineHeight: `13px`,
      border: `1px solid ${themeData["colorScheme.surface.level100"]}`,
      color: themeData["basics.colors.primary.white"],
      backgroundColor: `#0696d7`,
      borderRadius: `4px`,
      pointerEvents: `none`,
      fontWeight: 400,
      fontFamily: themeData["notifications.fontFamily"],
      margin: 0
    }, showCount ? {
      display: `block`
    } : {
      display: `none`
    }),
    image: {
      height: `48px`,
      width: `48px`,
      overflow: `hidden`,
      borderRadius: `4px`
    },
    emptyState: {
      display: `flex`,
      flexDirection: `column`,
      alignItems: `center`
    },
    emptyStateImage: {
      marginTop: `20px`
    },
    emptyStateMessage: {
      margin: `20px 0 37px`
    }
  };
  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

function ImagePresenter(props) {
  return /*#__PURE__*/React.createElement("img", _extends$1({
    className: css(stylesheet$1({}, {}).image)
  }, props));
}
ImagePresenter.__docgenInfo = {
  "description": "",
  "displayName": "ImagePresenter"
};

var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 89
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Bell_svg__a",
    d: "M0 .347h75.716v88.291H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.156 61.197c0 1.867 0 3.708.026 5.228.062 5.369 3.669 10.738 10.825 14.833 14.371 8.256 37.597 8.296 51.877.094 7.083-4.07 10.636-9.406 10.665-14.75v-5.427l-73.393.022z",
    fill: "#B4C1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.157 60.994C1.22 49.357 17.702 40.012 37.969 40.12c20.268.109 36.647 9.631 36.583 21.268C74.49 73.026 58.007 82.37 37.74 82.26c-20.268-.109-36.646-9.63-36.583-21.267",
    fill: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.727 46.324a40.231 40.231 0 00-5.476-2.59L45.694 45.18 46.767 70.3c11.531-.29 15.516 2.315 21.524 2.782 9.672-8.184 8.138-19.45-4.564-26.758",
    fill: "#CFD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.833 45.466l-16.465-.195s-6.153 13.477-6.713 13.458l-.979 9.971c.56.019 8.728-.43 13.979-3.411 7.029-4.002 13.116-9.606 11.323-14.19-.73-1.79-1.118-3.7-1.145-5.633M11.924 45.466l16.465-.195s6.153 13.477 6.713 13.458l.974 9.971c-.56.019-8.727-.43-13.978-3.411-7.029-4.002-13.116-9.606-11.323-14.19a15.631 15.631 0 001.149-5.633",
    fill: "#7992A0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Bell_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bell_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.371.347a3.889 3.889 0 00-1.956.503L32.93 3.426c-.796.445-2.15 1.621-2.15 4.403.012.95.158 1.892.434 2.8a27.48 27.48 0 00-11.637 5.507c-4.945 4.063-7.662 9.486-7.636 15.27v13.416c-.244.134-.476.26-.695.387C4.404 49.156.455 54.377.04 60.021L0 61.186c0 2.102 0 3.864.026 5.235.065 6.03 4.12 11.657 11.407 15.842 7.153 4.11 16.607 6.375 26.662 6.375 9.956 0 19.323-2.232 26.374-6.28 7.207-4.15 11.207-9.743 11.247-15.75v-5.426l-.04-1.161c-.53-5.597-4.52-10.782-11.352-14.703-.168-.098-.339-.192-.51-.286V31.407c0-5.789-2.748-11.194-7.705-15.257-2.344-1.906-5-3.4-7.851-4.414v-.383c0-3.774-2.589-8.22-5.89-10.13a5.991 5.991 0 00-2.993-.861L39.37.347zm.004 1.176c.844.03 1.667.28 2.385.724 2.931 1.682 5.31 5.763 5.31 9.11.001.394-.037.788-.114 1.175a25.772 25.772 0 018.364 4.52c4.84 3.979 7.272 9.163 7.272 14.362v13.024c0 .438.023.876.048 1.314.364.188.727.38 1.062.579 7.16 4.113 10.77 9.486 10.829 14.858v5.427c-.03 5.347-3.582 10.68-10.666 14.75-7.083 4.07-16.44 6.125-25.789 6.125-9.425 0-18.872-2.073-26.087-6.219-7.156-4.11-10.763-9.479-10.825-14.833-.018-1.52-.026-3.361-.026-5.228-.062-5.427 3.491-10.832 10.666-14.953.41-.235.832-.463 1.258-.683.018-.362.025-.724.025-1.086V31.432c0-5.202 2.39-10.405 7.219-14.37a26.547 26.547 0 0112.461-5.532 9.73 9.73 0 01-.818-3.686c0-1.68.6-2.855 1.567-3.398.277-.162 3.564-2.047 4.48-2.576a2.752 2.752 0 011.375-.361l.004.014z",
    fill: "#7F909A",
    mask: "url(#Bell_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.175 52.337a20.527 20.527 0 01-1.557-7.89V31.421c0-5.2-2.44-10.394-7.273-14.363-9.687-7.934-25.36-7.938-35.01 0-4.83 3.98-7.233 9.167-7.219 14.37v13.057a20.114 20.114 0 01-1.534 7.84c-2.138 5.043.269 10.597 7.222 14.55 10.596 6.032 27.723 6.06 38.25.073 6.826-3.882 9.186-9.649 7.12-14.612",
    fill: "#CFD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.356 23.343a20.544 20.544 0 00-4.967-6.273c-4.476-3.85-10.298-5.84-16.153-5.945-6.141.105-12.236 2.091-16.912 5.937a19.83 19.83 0 00-6.182 8.531 1.089 1.089 0 00-.04.116c-.142 4.168 2.043 8.372 6.567 11.577 8.727 6.15 22.884 6.172 31.586.036 5.363-3.802 7.4-9.059 6.101-13.979",
    fill: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.833 22.124a21.105 21.105 0 00-4.499-5.065 26.608 26.608 0 00-11.937-5.427l-5.539 5.59c5.404 3.704 11.604 2.977 16.931 3.339 2.273.155 3.866.745 5.044 1.563",
    fill: "#CFD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.229 61.295h-.673c0 5.38-3.538 10.752-10.665 14.833-7.127 4.08-16.451 6.125-25.818 6.125-9.43 0-18.88-2.077-26.099-6.22C4.862 71.95 1.251 66.628 1.15 61.284H.694v4.085C2.15 69.79 5.822 73.834 11.407 77.04c7.156 4.11 16.633 6.374 26.68 6.374 9.96 0 19.331-2.232 26.386-6.28 5.774-3.314 9.48-7.55 10.756-12.182v-3.657zM39.702 17.695h3.044c1.12-.644 2.745-1.577 3.345-1.917.69-.39 1.778-1.32 2.07-3.336l-1.172-.105a5.082 5.082 0 01-.083.41v.025c-.09.348-.228.682-.411.99a.355.355 0 00-.03.055 3.748 3.748 0 01-.134.188l-.11.149-.123.137-.17.16a2.268 2.268 0 01-.415.304l-.153.086h-.026l-.65.362-.073.04-.2.115-.12.07c-.055.032-.11.064-.167.093l-.091.054-.23.13-.214.127-.13.073-2.437 1.4a2.707 2.707 0 01-1.32.362v.028zM31.258 11.346s2.738 5.387 6.142 5c1.415-.163-3.015-6.722-3.015-6.722l-3.127 1.722z",
    fill: "#7F909A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.07 11.375c0 1.675-.594 2.847-1.557 3.394-.964.546-4.491 2.575-4.491 2.575L33.495 4.472l4.501-2.587c.96-.55 2.291-.463 3.76.38 2.935 1.682 5.313 5.763 5.313 9.11",
    fill: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.615 6.379l-8.219 4.764 3.637 6.201s3.53-2.033 4.49-2.575c.96-.543 1.557-1.719 1.557-3.394a10.58 10.58 0 00-1.465-4.996",
    fill: "#B4C1C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.487 4.48c2.06-1.198 5.42.71 7.507 4.259 2.086 3.55 2.107 7.399.047 8.597-2.06 1.198-5.42-.709-7.506-4.259-2.086-3.55-2.107-7.399-.048-8.597",
    fill: "#CFD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.615 8.275c.865-.503 2.276.297 3.152 1.787.876 1.491.884 3.107.019 3.61-.865.504-2.277-.297-3.152-1.787-.876-1.49-.884-3.107-.02-3.61",
    fill: "#7F909A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88 2.953h-.138c-1.266.77-1.255.763-2.767 1.7l-.299 2.135.313.43c.196-1.979 1.32-3.104 2.91-3.104.843.03 1.664.28 2.381.724 2.913 1.69 5.305 5.763 5.305 9.11 0 2.37-1.192 3.737-2.927 3.737h-.033 2.811c.826-.861 1.31-2.171 1.31-3.745 0-3.773-2.59-8.216-5.895-10.13a5.984 5.984 0 00-2.964-.88l-.007.023z",
    fill: "#7F909A"
  }))));
};

function EmptyStatePresenter(_ref) {
  let {
    message,
    stylesheet: customStylesheet
  } = _ref;
  const styles = stylesheet$1({
    stylesheet: customStylesheet
  }, {});
  return /*#__PURE__*/React.createElement("div", {
    className: css(styles.emptyState)
  }, /*#__PURE__*/React.createElement(SvgBell, {
    role: "presentation",
    className: css(styles.emptyStateImage)
  }), /*#__PURE__*/React.createElement(Typography, {
    style: styles.emptyStateMessage
  }, message));
}
EmptyStatePresenter.defaultProps = {
  message: "You currently have no notifications"
};
EmptyStatePresenter.propTypes = {
  message: PropTypes.string,
  stylesheet: PropTypes.func
};
EmptyStatePresenter.__docgenInfo = {
  "description": "",
  "displayName": "EmptyStatePresenter",
  "props": {
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "\"You currently have no notifications\"",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

const _excluded$b = ["count", "onClick", "title"];
function IndicatorPresenter(props) {
  const {
    count,
    onClick,
    title
  } = props,
        otherProps = _objectWithoutProperties$1(props, _excluded$b);

  const {
    className
  } = otherProps;
  const indicatorClassName = createCustomClassNames$1(className, "indicator");
  const indicatorCountClassName = createCustomClassNames$1(className, "indicator-count");
  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref => {
    let {
      resolvedRoles,
      metadata
    } = _ref;
    const styles = stylesheet$1(props, resolvedRoles);
    const NotificationIcon = metadata.densityId === "high-density" ? Notification16 : Notification24;
    return /*#__PURE__*/React.createElement("div", {
      className: cx([indicatorClassName, css(styles.indicator)])
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: onClick,
      icon: /*#__PURE__*/React.createElement(NotificationIcon, null),
      title: title
    }), /*#__PURE__*/React.createElement("div", {
      className: cx([indicatorCountClassName, css(styles.indicatorCount)])
    }, count));
  });
}
IndicatorPresenter.defaultProps = {
  title: "View notifications"
};
IndicatorPresenter.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func,
  title: PropTypes.string
};
IndicatorPresenter.__docgenInfo = {
  "description": "",
  "displayName": "IndicatorPresenter",
  "props": {
    "count": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "\"View notifications\"",
        "computed": false
      }
    }
  }
};

const TRANSITION_DURATION$2 = 300;
/**
 * @typedef {Object} Payload
 * @property {string} transitionStatus
 * @property {function(MouseEvent): void} handleDismissButtonClick
 */

const NotificationBehavior = props => {
  const [height, setHeight] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const containerRef = useRef(null);
  /**
   * @param {HTMLDivElement} containerRef
   */

  const refContainer = containerRefParams => {
    containerRef.current = containerRefParams;
  };

  const handleExit = () => {
    const {
      onDismiss
    } = props;
    if (onDismiss) onDismiss();
  };
  /**
   * Sets the current height of the notification
   * so that the height transition can occur
   */


  const prepareHideTransition = () => new Promise(resolve => {
    setHeight(`${containerRef.current.clientHeight}px`);
    window.requestAnimationFrame(resolve);
  });
  /**
   * Begins the hide transition by setting the `isVisible` prop
   * The height is then controlled via CSS in the `NotificationPresenter`
   *
   * This method calls `requestAnimationFrame` again to ensure that a repaint occurs.
   * @see https://stackoverflow.com/a/42302185
   */


  const startHideTransition = () => {
    window.requestAnimationFrame(() => {
      setHeight("");
      setIsVisible(false);
    });
  };

  const hide = () => {
    prepareHideTransition().then(() => startHideTransition());
  };

  const handleDismissButtonClick = () => {
    hide();
  };

  const innerRef = refContainer;
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(Transition, {
    in: isVisible,
    onExited: handleExit,
    timeout: TRANSITION_DURATION$2
  }, transitionStatus => children({
    handleDismissButtonClick,
    height,
    innerRef,
    transitionStatus
  }));
};

NotificationBehavior.displayName = "NotificationBehavior";
NotificationBehavior.propTypes = {
  /** Notification content */
  children: PropTypes.func.isRequired,

  /** A callback called when user dismisses a featured notification */
  onDismiss: PropTypes.func
};
NotificationBehavior.__docgenInfo = {
  "description": "@typedef {Object} Payload\n@property {string} transitionStatus\n@property {function(MouseEvent): void} handleDismissButtonClick",
  "displayName": "NotificationBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Notification content"
    },
    "onDismiss": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A callback called when user dismisses a featured notification"
    }
  }
};

const _excluded$a = ["hasHover", "onClick", "stylesheet", "title"];
function DismissButtonPresenter(_ref) {
  let {
    hasHover,
    onClick,
    stylesheet: customStylesheet,
    title
  } = _ref,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$a);

  const {
    className
  } = otherProps;
  const dismissButtonClassName = createCustomClassNames$1(className, "dismiss-button");
  const styles = stylesheet$1({
    hasHover,
    stylesheet: customStylesheet
  }, {});
  return /*#__PURE__*/React.createElement("div", {
    className: cx([dismissButtonClassName, css(styles.dismissButton)])
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    icon: /*#__PURE__*/React.createElement(CloseSUI, null),
    title: title
  }));
}
DismissButtonPresenter.defaultProps = {
  title: "Dismiss featured notification"
};
DismissButtonPresenter.propTypes = {
  hasHover: PropTypes.bool,
  onClick: PropTypes.func,
  stylesheet: PropTypes.func,
  title: PropTypes.string
};
DismissButtonPresenter.__docgenInfo = {
  "description": "",
  "displayName": "DismissButtonPresenter",
  "props": {
    "hasHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "\"Dismiss featured notification\"",
        "computed": false
      }
    }
  }
};

const _excluded$9 = ["children", "dismissButtonTitle", "hasHover", "height", "image", "innerRef", "onDismissButtonClick", "onNotificationClick", "onMouseEnter", "onMouseLeave", "showDismissButton", "stylesheet", "timestamp"];
function NotificationPresenter(props) {
  const {
    children,
    dismissButtonTitle,
    hasHover,
    height,
    image,
    innerRef,
    onDismissButtonClick,
    onNotificationClick,
    onMouseEnter,
    onMouseLeave,
    showDismissButton,
    stylesheet: customStylesheet,
    timestamp
  } = props,
        otherProps = _objectWithoutProperties$1(props, _excluded$9);

  const {
    className
  } = otherProps;
  const notificationContentClassName = createCustomClassNames$1(className, "notification-content");
  const notificationContentImageClassName = createCustomClassNames$1(className, "notification-content-image");
  const notificationContentTextClassName = createCustomClassNames$1(className, "notification-content-text");
  return (
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
    React.createElement(ThemeContext.Consumer, null, _ref => {
      let {
        resolvedRoles
      } = _ref;
      const styles = stylesheet$1(props, resolvedRoles);
      return /*#__PURE__*/React.createElement("div", {
        className: cx([className, css(styles.notification)]),
        onClick: onNotificationClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: innerRef,
        role: "listitem",
        style: {
          height
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: cx([notificationContentClassName, css(styles.notificationContent)])
      }, image ? /*#__PURE__*/React.createElement("div", {
        className: cx([notificationContentImageClassName, css(styles.notificationContentImage)])
      }, image) : null, /*#__PURE__*/React.createElement("div", {
        className: cx([notificationContentTextClassName, css(styles.notificationContentText)])
      }, /*#__PURE__*/React.createElement(RichText, {
        size: "small"
      }, children), timestamp, showDismissButton ? /*#__PURE__*/React.createElement(DismissButtonPresenter, {
        className: className,
        hasHover: hasHover,
        onClick: onDismissButtonClick,
        stylesheet: customStylesheet,
        title: dismissButtonTitle
      }) : null)));
    })
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

  );
}
NotificationPresenter.propTypes = {
  children: PropTypes.node,
  dismissButtonTitle: PropTypes.string,
  hasHover: PropTypes.bool,
  height: PropTypes.string,
  image: PropTypes.node,
  innerRef: PropTypes.func,
  onDismissButtonClick: PropTypes.func,
  onNotificationClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  showDismissButton: PropTypes.bool,
  stylesheet: PropTypes.func,
  timestamp: PropTypes.node
};
NotificationPresenter.__docgenInfo = {
  "description": "",
  "displayName": "NotificationPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "dismissButtonTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "hasHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "image": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDismissButtonClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onNotificationClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "showDismissButton": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "timestamp": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

const _excluded$8 = ["dismissButtonTitle", "featured", "image", "onDismiss", "onNotificationClick", "onMouseEnter", "onMouseLeave", "showDismissButton", "stylesheet", "timestamp", "type", "unread"];

const Notification = props => {
  /**
   * @param {NotificationShape} shape
   * @returns {import("react").ReactElement}
   */
  const renderChildren = () => {
    const {
      children,
      hideFlyout,
      onDismiss: dismiss
    } = props;

    if (typeof children !== "function") {
      return children;
    }

    return children({
      dismiss,
      hideFlyout
    });
  };

  const {
    dismissButtonTitle,
    featured,
    image,
    onDismiss,
    onNotificationClick,
    onMouseEnter,
    onMouseLeave,
    // Featured notifications show the dismiss button by default
    showDismissButton = featured,
    stylesheet,
    timestamp,
    type,
    unread
  } = props,
        otherProps = _objectWithoutProperties$1(props, _excluded$8);

  const {
    className
  } = otherProps;
  return /*#__PURE__*/React.createElement(NotificationBehavior, {
    onDismiss: onDismiss
  }, _ref => {
    let {
      handleDismissButtonClick,
      height,
      innerRef,
      transitionStatus
    } = _ref;
    return /*#__PURE__*/React.createElement(ControlBehavior, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, _ref2 => {
      let {
        hasHover,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      } = _ref2;
      return /*#__PURE__*/React.createElement(NotificationPresenter, {
        className: className,
        dismissButtonTitle: dismissButtonTitle,
        featured: featured,
        hasHover: hasHover,
        height: height,
        image: image,
        innerRef: innerRef,
        onDismissButtonClick: handleDismissButtonClick,
        onNotificationClick: onNotificationClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        showDismissButton: showDismissButton,
        stylesheet: stylesheet,
        timestamp: timestamp,
        transitionStatus: transitionStatus,
        type: type,
        unread: unread
      }, renderChildren());
    });
  });
};

Notification.displayName = "Notification";
Notification.propTypes = {
  /** Notification content */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** Title HTML attribute for the dismiss button */
  dismissButtonTitle: PropTypes.string,

  /** Determines whether the notification is featured */
  featured: PropTypes.bool,

  /** An action provided hide the flyout. This is provided to the `children` render prop */
  hideFlyout: PropTypes.func,

  /** An image to display such as an avatar or and icon */
  image: PropTypes.node,

  /** A callback called when user dismisses a featured notification */
  onDismiss: PropTypes.func,

  /** A callback when the user clicks anywhere within the notification */
  onNotificationClick: PropTypes.func,

  /**
   * Triggers when the user's mouse is over the notification
   */
  onMouseEnter: PropTypes.func,

  /**
   * Triggers when the user's mouse is no longer over the notification
   */
  onMouseLeave: PropTypes.func,

  /** Determines whether the dismiss button is shown */
  showDismissButton: PropTypes.bool,

  /** Function to modify the component's styles */
  stylesheet: PropTypes.func,

  /** Timestamp component */
  timestamp: PropTypes.node,

  /** Determines notification variant */
  type: PropTypes.string,

  /** Determines whether notification has not been read */
  unread: PropTypes.bool
};
Notification.defaultProps = {
  /**
   * This is an action that's provided to the consumer,
   * as a result a value must always be available.
   */
  hideFlyout: () => {},
  onNotificationClick: () => {}
};
Notification.__docgenInfo = {
  "description": "",
  "displayName": "Notification",
  "props": {
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Notification content"
    },
    "dismissButtonTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Title HTML attribute for the dismiss button"
    },
    "featured": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines whether the notification is featured"
    },
    "hideFlyout": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "An action provided hide the flyout. This is provided to the `children` render prop",
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      }
    },
    "image": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "An image to display such as an avatar or and icon"
    },
    "onDismiss": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A callback called when user dismisses a featured notification"
    },
    "onNotificationClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A callback when the user clicks anywhere within the notification",
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      }
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is over the notification"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Triggers when the user's mouse is no longer over the notification"
    },
    "showDismissButton": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines whether the dismiss button is shown"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    },
    "timestamp": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Timestamp component"
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Determines notification variant"
    },
    "unread": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines whether notification has not been read"
    }
  }
};

const _excluded$7 = ["key"],
      _excluded2$2 = ["children", "content", "id", "unread"];
/** @typedef {null|undefined|NotificationElements} Input */

/**
 * @typedef {Object} ParsedNotification
 * @property {string} id
 * @property {string} key
 * @property {NotificationContent} [content]
 * @property {boolean} [featured]
 * @property {function(): void} [onDismiss]
 * @property {boolean} [showDismissButton]
 * @property {import("react").ReactElement} [timestamp]
 * @property {string} [type]
 * @property {boolean} unread
 */

/**
 * Converts the given notifications input into an array
 * @param {Input} input
 * @returns {Object[]}
 */

function normalizeInput(input) {
  if (input == null) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  const element = Children.only(input);

  if (element.type === Notification) {
    return [element];
  }

  throw new Error("Invalid notifications value.");
}
/**
 * @param {Object} value
 * @param {number} index
 * @returns {ParsedNotification}
 */


function parseNotification(value, index) {
  const {
    key = `notification-${index}`
  } = value,
        otherValues = _objectWithoutProperties$1(value, _excluded$7);

  const _ref = otherValues.props || otherValues,
        {
    children,
    content = children,
    id = index.toString(),
    unread = true
  } = _ref,
        props = _objectWithoutProperties$1(_ref, _excluded2$2);

  return _objectSpread2$1({
    id,
    key,
    content,
    unread
  }, props);
}
/**
 * @param {Input} input
 * @returns {ParsedNotification[]}
 */


function parseNotifications(input) {
  return normalizeInput(input).map(parseNotification);
}

const _excluded$6 = ["id", "unread"];
/** @typedef {import("./parseNotifications").Input} NotificationsInput */

/** @typedef {import("./parseNotifications").ParsedNotification} ParsedNotification */

/** @typedef {import("./NotificationBehavior").Payload} NotificationBehaviorPayload */

/**
 * @typedef {Object} Payload
 * @property {Function} dismissNotification
 * @property {ParsedNotification[]} notifications
 * @property {boolean} showUnreadCount
 * @property {number} unreadCount
 */

/**
 * @typedef {Object} Props
 * @property {function(Payload): import("react").ReactElement} [children]
 * @property {NotificationsInput} [notifications]
 * @property {number} [unreadCount]
 */

/**
 * @typedef {Object} State
 * @property {string[]} dismissedNotifications An array of notification IDs that have been dismissed
 * @property {ParsedNotification[]} notifications
 * @property {string[]} readNotifications An array of notification IDs that have been read
 */

class NotificationFlyoutBehavior extends Component {
  constructor() {
    super(...arguments);

    _defineProperty$1(this, "props", void 0);

    _defineProperty$1(this, "state", {
      dismissedNotifications: [],
      notifications: [],
      readNotifications: []
    });

    _defineProperty$1(this, "dismissNotification", id => {
      this.setState({
        // eslint-disable-next-line react/no-access-state-in-setstate
        dismissedNotifications: this.state.dismissedNotifications.concat(id)
      });
    });

    _defineProperty$1(this, "handleClose", () => {
      this.markAllNotificationsRead();
    });
  }

  /**
   * @param {Props} nextProps
   * @returns {State | null}
   */
  static getDerivedStateFromProps(nextProps) {
    return {
      notifications: parseNotifications(nextProps.notifications)
    };
  }
  /**
   * @returns {ParsedNotification[]}
   */


  getNotifications() {
    const {
      dismissedNotifications,
      notifications,
      readNotifications
    } = this.state;

    const updateReadStatus = _ref => {
      let {
        id,
        unread
      } = _ref,
          otherProps = _objectWithoutProperties$1(_ref, _excluded$6);

      return _objectSpread2$1({
        id,
        unread: unread && !readNotifications.includes(id)
      }, otherProps);
    };

    const isNotDismissed = _ref2 => {
      let {
        id
      } = _ref2;
      return !dismissedNotifications.includes(id);
    };

    return notifications.map(updateReadStatus).filter(isNotDismissed);
  }
  /** @returns {number} */


  getUnreadCount() {
    const {
      unreadCount: controlledUnreadCount
    } = this.props;
    return controlledUnreadCount !== undefined ? controlledUnreadCount : this.deriveUnreadCount();
  }
  /**
   * Action to dismiss a notification
   * @param {string} id
   */


  /**
   * @param {ParsedNotification[]} notifications
   */
  deriveUnreadCount() {
    return this.getNotifications().reduce((count, _ref3) => {
      let {
        unread
      } = _ref3;
      return unread ? count + 1 : count;
    }, 0);
  }

  markAllNotificationsRead() {
    const notifications = this.getNotifications();
    const {
      readNotifications
    } = this.state;
    const nextRead = notifications.reduce((result, notification) => {
      const {
        id
      } = notification;
      if (!result.includes(id)) result.push(id);
      return result;
    }, readNotifications.slice());
    this.setState({
      readNotifications: nextRead
    });
  }
  /**
   * @returns {import("react").ReactElement}
   */


  render() {
    const {
      dismissNotification,
      handleClose
    } = this;
    const notifications = this.getNotifications();
    const unreadCount = this.getUnreadCount();
    const showUnreadCount = unreadCount > 0;
    return this.props.children({
      dismissNotification,
      handleClose,
      notifications,
      showUnreadCount,
      unreadCount
    });
  }

}

_defineProperty$1(NotificationFlyoutBehavior, "propTypes", {
  /** Render prop */
  children: PropTypes.func.isRequired,

  /** Rendered notifications */
  notifications: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]))]),

  /** When provided, it overrides the derived unread notification count */
  unreadCount: PropTypes.number
});

NotificationFlyoutBehavior.__docgenInfo = {
  "description": "@typedef {Object} State\n@property {string[]} dismissedNotifications An array of notification IDs that have been dismissed\n@property {ParsedNotification[]} notifications\n@property {string[]} readNotifications An array of notification IDs that have been read",
  "displayName": "NotificationFlyoutBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Render prop"
    },
    "notifications": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "node"
            }, {
              "name": "shape",
              "value": {}
            }]
          }
        }]
      },
      "required": false,
      "description": "Rendered notifications"
    },
    "unreadCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "When provided, it overrides the derived unread notification count"
    }
  }
};

/** 50px per the design spec plus 30px for the height of the title */

const BOTTOM_SPACING = 80;
const TRANSITION_DURATION$1 = 300;
/**
 * @param {HTMLDivElement} listWrapper
 * @returns {string}
 */

function calculateListMaxHeight(listWrapper) {
  if (!listWrapper) return "";
  const {
    top: listWrapperTop
  } = listWrapper.getBoundingClientRect(); // Distance between the top of the list wrapper and the spacing at the bottom of the screen

  const height = window.innerHeight - BOTTOM_SPACING - listWrapperTop;
  return `${height}px`;
}

const PanelBehavior = props => {
  const [listMaxHeight, setListMaxHeight] = useState("");
  const listWrapperRef = useRef(null);

  const updateMaxHeight = () => {
    setListMaxHeight(calculateListMaxHeight(listWrapperRef.current));
  };

  const handleResize = () => {
    updateMaxHeight();
  };

  const bindResize = () => {
    window.addEventListener("resize", handleResize);
  };

  const unbindResize = () => {
    window.removeEventListener("resize", handleResize);
  };
  /**
   * @param {HTMLDivElement} listWrapperRef
   */


  const refListWrapper = value => {
    listWrapperRef.current = value;
  };

  const {
    children,
    loading
  } = props;
  useEffect(() => {
    bindResize();
    updateMaxHeight();
    return () => {
      unbindResize();
    };
  }, []);
  useEffect(() => {
    if (props.transitionStatus === transitionStatuses$1.HIDDEN || props.transitionStatus === transitionStatuses$1.EXITED) {
      window.requestAnimationFrame(() => {
        updateMaxHeight();
      });
    }
  }, [props]);
  return /*#__PURE__*/React.createElement(Transition, {
    in: loading,
    timeout: TRANSITION_DURATION$1
  }, loadingTransitionState => children({
    loadingTransitionState,
    listMaxHeight,
    refListWrapper
  }));
};

PanelBehavior.propTypes = {
  children: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  transitionStatus: PropTypes.oneOf(AVAILABLE_TRANSITION_STATUSES$1)
};
PanelBehavior.defaultProps = {
  loading: false
};
PanelBehavior.__docgenInfo = {
  "description": "",
  "displayName": "PanelBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "transitionStatus": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_TRANSITION_STATUSES"
      },
      "required": false,
      "description": ""
    }
  }
};

function PanelPresenter$1(_ref) {
  let {
    children,
    heading,
    innerRef,
    listMaxHeight,
    loadingTransitionState,
    onScroll,
    refListWrapper,
    stylesheet: customStylesheet
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref2 => {
    let {
      resolvedRoles
    } = _ref2;
    const styles = stylesheet$1({
      transitionState: null,
      loadingTransitionState,
      stylesheet: customStylesheet
    }, resolvedRoles);
    return /*#__PURE__*/React.createElement(Panel$1, {
      innerRef: innerRef
    }, /*#__PURE__*/React.createElement(Typography, {
      elementType: "header",
      style: styles.panelTitle
    }, heading), /*#__PURE__*/React.createElement("section", {
      className: css(styles.panelContainer),
      ref: refListWrapper,
      style: {
        maxHeight: listMaxHeight
      }
    }, /*#__PURE__*/React.createElement("div", {
      role: "list",
      onScroll: onScroll
    }, children)), /*#__PURE__*/React.createElement("footer", {
      className: css(styles.panelLoading)
    }, /*#__PURE__*/React.createElement(ProgressRing, {
      size: "s"
    })));
  });
}
PanelPresenter$1.defaultProps = {
  heading: "Notifications"
};
PanelPresenter$1.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.node,
  innerRef: PropTypes.func.isRequired,
  listMaxHeight: PropTypes.string,
  loadingTransitionState: PropTypes.oneOf([UNMOUNTED, EXITED, ENTERING, ENTERED, EXITING]),
  onScroll: PropTypes.func,
  refListWrapper: PropTypes.func,
  stylesheet: PropTypes.func
};
PanelPresenter$1.__docgenInfo = {
  "description": "",
  "displayName": "PanelPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "heading": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "\"Notifications\"",
        "computed": false
      }
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "listMaxHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "loadingTransitionState": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "import {\n  UNMOUNTED,\n  EXITED,\n  ENTERING,\n  ENTERED,\n  EXITING,\n} from \"react-transition-group/Transition\";",
          "computed": true
        }, {
          "value": "import {\n  UNMOUNTED,\n  EXITED,\n  ENTERING,\n  ENTERED,\n  EXITING,\n} from \"react-transition-group/Transition\";",
          "computed": true
        }, {
          "value": "import {\n  UNMOUNTED,\n  EXITED,\n  ENTERING,\n  ENTERED,\n  EXITING,\n} from \"react-transition-group/Transition\";",
          "computed": true
        }, {
          "value": "import {\n  UNMOUNTED,\n  EXITED,\n  ENTERING,\n  ENTERED,\n  EXITING,\n} from \"react-transition-group/Transition\";",
          "computed": true
        }, {
          "value": "import {\n  UNMOUNTED,\n  EXITED,\n  ENTERING,\n  ENTERED,\n  EXITING,\n} from \"react-transition-group/Transition\";",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "refListWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

function Panel(props) {
  const {
    children,
    heading,
    innerRef,
    loading,
    onScroll,
    transitionStatus,
    stylesheet
  } = props;
  return /*#__PURE__*/React.createElement(PanelBehavior, {
    loading: loading,
    transitionStatus: transitionStatus
  }, _ref => {
    let {
      listMaxHeight,
      loadingTransitionState,
      refListWrapper
    } = _ref;
    return /*#__PURE__*/React.createElement(PanelPresenter$1, {
      heading: heading,
      innerRef: innerRef,
      listMaxHeight: listMaxHeight,
      loadingTransitionState: loadingTransitionState,
      onScroll: onScroll,
      refListWrapper: refListWrapper,
      stylesheet: stylesheet
    }, children);
  });
}
Panel.propTypes = {
  children: PropTypes.node,
  heading: PropTypes.string,
  innerRef: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onScroll: PropTypes.func,
  stylesheet: PropTypes.func,
  transitionStatus: PropTypes.string
};
Panel.__docgenInfo = {
  "description": "",
  "displayName": "Panel",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "heading": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "transitionStatus": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

const _excluded$5 = ["content", "dismissButtonTitle", "featured", "id", "image", "key", "onDismiss", "onNotificationClick", "showDismissButton", "stylesheet", "timestamp", "type", "unread"],
      _excluded2$1 = ["alterCoordinates", "anchorPoint", "children", "emptyMessage", "fallbackAnchorPoints", "heading", "indicatorTitle", "loading", "onClick", "onClickOutside", "onScroll", "open", "notifications", "unreadCount", "stylesheet"];
/** @typedef {import("./behaviors/parseNotifications").ParsedNotification} ParsedNotification */

/**
 * @param {Object} payload
 * @returns {function(ParsedNotification): JSX}
 */

function createNotificationRenderer(_ref) {
  let {
    hideFlyout,
    dismissNotification
  } = _ref;

  /* eslint-disable-next-line react/prop-types */
  return function renderNotification(notification) {
    const {
      content,
      dismissButtonTitle,
      featured,
      id,
      image,
      key,
      onDismiss,
      onNotificationClick,
      showDismissButton,
      stylesheet,
      timestamp,
      type,
      unread
    } = notification,
          otherProps = _objectWithoutProperties$1(notification, _excluded$5);

    const {
      className
    } = otherProps;
    const handleDismiss = combineEventHandlers$1(onDismiss, () => dismissNotification(id));
    return /*#__PURE__*/React.createElement(Notification, {
      className: className,
      dismissButtonTitle: dismissButtonTitle,
      featured: featured,
      hideFlyout: hideFlyout,
      image: image,
      key: key,
      onDismiss: handleDismiss,
      onNotificationClick: onNotificationClick,
      showDismissButton: showDismissButton,
      stylesheet: stylesheet,
      timestamp: timestamp,
      type: type,
      unread: unread
    }, content);
  };
}

function createPanelRenderer(_ref2) {
  let {
    emptyMessage,
    dismissNotification,
    notifications,
    loading,
    heading,
    stylesheet
  } = _ref2;
  return function renderPanel(_ref3) {
    let {
      /* eslint-disable react/prop-types */
      hideFlyout,
      handleScroll,
      innerRef,
      transitionStatus
    } = _ref3;
    const isEmpty = notifications.length === 0;
    return /*#__PURE__*/React.createElement(Panel, {
      heading: heading,
      innerRef: innerRef,
      loading: loading,
      onScroll: handleScroll,
      transitionStatus: transitionStatus,
      stylesheet: stylesheet
    }, isEmpty ? /*#__PURE__*/React.createElement(EmptyStatePresenter, {
      message: emptyMessage,
      stylesheet: stylesheet
    }) : notifications.map(createNotificationRenderer({
      hideFlyout,
      dismissNotification
    })));
  };
}

function NotificationsFlyout(props) {
  const {
    alterCoordinates,
    anchorPoint,
    children,
    emptyMessage,
    fallbackAnchorPoints,
    heading,
    indicatorTitle,
    loading,
    onClick,
    onClickOutside,
    onScroll,
    open,
    notifications: notificationsInput = children,
    unreadCount: controlledUnreadCount,
    stylesheet
  } = props,
        otherProps = _objectWithoutProperties$1(props, _excluded2$1);

  const {
    className
  } = otherProps;
  return /*#__PURE__*/React.createElement(NotificationFlyoutBehavior, {
    unreadCount: controlledUnreadCount,
    notifications: notificationsInput
  }, _ref4 => {
    let {
      dismissNotification,
      handleClose,
      notifications,
      showUnreadCount,
      unreadCount
    } = _ref4;
    return /*#__PURE__*/React.createElement(Flyout$1, {
      alterCoordinates: alterCoordinates,
      anchorPoint: anchorPoint,
      className: className,
      fallbackAnchorPoints: fallbackAnchorPoints,
      onClickOutside: onClickOutside,
      onClose: handleClose,
      onScroll: onScroll,
      open: open,
      panel: createPanelRenderer({
        emptyMessage,
        dismissNotification,
        notifications,
        loading,
        heading,
        stylesheet
      }),
      stylesheet: stylesheet
    }, _ref5 => {
      let {
        handleClick
      } = _ref5;
      return /*#__PURE__*/React.createElement(IndicatorPresenter, {
        className: className,
        onClick: combineEventHandlers$1(onClick, handleClick),
        count: unreadCount,
        showCount: showUnreadCount,
        title: indicatorTitle,
        stylesheet: stylesheet
      });
    });
  });
}
NotificationsFlyout.defaultProps = {
  anchorPoint: anchorPoints$1.TOP_RIGHT
};
NotificationsFlyout.propTypes = {
  /** Manipulate flyout coordinates before each render */
  alterCoordinates: PropTypes.func,

  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS$1),

  /** Rendered notifications. It can contain one or more <Notification /> components. */
  children: PropTypes.node,

  /** The message displayed when there are no notifications */
  emptyMessage: PropTypes.string,

  /**
   * When the flyout overflows the viewport, it'll attempt to
   * use the given anchor points in order to keep the flyout
   * within the viewport.
   */
  fallbackAnchorPoints: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS$1)),

  /** Flyout panel heading */
  heading: PropTypes.string,

  /** Indicator button title */
  indicatorTitle: PropTypes.string,

  /** Determines whether the loading animation is shown */
  loading: PropTypes.bool,

  /**
   * Rendered notifications.
   * It takes precedent over `children`, and accepts an array
   * containing any combination of <Notification /> components
   * and Notification models
   */
  notifications: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.object])),

  /** Function called when the flyout is opened */
  onClick: PropTypes.func,

  /** Function called when the flyout is open, and a click event occurs outside the flyout */
  onClickOutside: PropTypes.func,

  /** Function called when the flyout panel is scrolled */
  onScroll: PropTypes.func,

  /** When provided, it overrides the flyout's open state */
  open: PropTypes.bool,

  /** Function to modify the component's styles */
  stylesheet: PropTypes.func,

  /** When provided, it overrides the derived unread notification count */
  unreadCount: PropTypes.number
};
NotificationsFlyout.__docgenInfo = {
  "description": "",
  "displayName": "NotificationsFlyout",
  "props": {
    "alterCoordinates": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Manipulate flyout coordinates before each render"
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target",
      "defaultValue": {
        "value": "anchorPoints.TOP_RIGHT",
        "computed": true
      }
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Rendered notifications. It can contain one or more <Notification /> components."
    },
    "emptyMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The message displayed when there are no notifications"
    },
    "fallbackAnchorPoints": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "enum",
          "computed": true,
          "value": "AVAILABLE_ANCHOR_POINTS"
        }
      },
      "required": false,
      "description": "When the flyout overflows the viewport, it'll attempt to\nuse the given anchor points in order to keep the flyout\nwithin the viewport."
    },
    "heading": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Flyout panel heading"
    },
    "indicatorTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Indicator button title"
    },
    "loading": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Determines whether the loading animation is shown"
    },
    "notifications": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "node"
          }, {
            "name": "object"
          }]
        }
      },
      "required": false,
      "description": "Rendered notifications.\nIt takes precedent over `children`, and accepts an array\ncontaining any combination of <Notification /> components\nand Notification models"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout is opened"
    },
    "onClickOutside": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout is open, and a click event occurs outside the flyout"
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout panel is scrolled"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "When provided, it overrides the flyout's open state"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    },
    "unreadCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "When provided, it overrides the derived unread notification count"
    }
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */

var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * @param {Array<function(...any): void>} handlers the event handler functions
 * @returns {function(...any): void} An event handler to add to an element
 */

function createAggregateEventHandler(handlers) {
  /**
   * This function needed to be moved out of `combineEventHandlers`
   * since babel doesn't handle nested functions using rest operators
   * properly.
   */
  return function aggregateEventHandler() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    handlers.forEach(function (handler) {
      if (handler) handler.apply(undefined, args);
    });
  };
}
/**
 * Combines multiple event handlers into one
 * @param {...function(...any): void} handlers the event handler functions
 * @returns {function(...any): void} An event handler to add to an element
 */


function combineEventHandlers() {
  for (var _len2 = arguments.length, handlers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    handlers[_key2] = arguments[_key2];
  }

  return createAggregateEventHandler(handlers);
}
/**
 * Returns a css className that combines what the user passes down and a string.
 * Ideally the string would map to the element's js style object's name.
 * @param {string} className
 * @param {string} appendedString
 * @returns {string} A string that looks like className__appendedString
 */


function createCustomClassNames(className, appendedString) {
  return className && className.split(" ").reduce(function (acc, cur) {
    return cx(acc, cur.trim() + "__" + appendedString);
  }, "");
}

var metadata = {
	colorSchemeName: "Light gray",
	colorSchemeId: "hig-light-gray",
	className: "hig--light-gray-theme",
	densityId: "medium-density",
	densityName: "Medium density",
	name: "Light gray, Medium density",
	fileName: "lightGrayMediumDensityTheme",
	id: "hig-light-gray-medium-density",
	__deprecated__: {
	}
};
var resolvedRoles = {
	"basics.borderRadii.none": "0",
	"basics.borderRadii.small": "0",
	"basics.borderRadii.medium": "2px",
	"basics.borderRadii.large": "4px",
	"basics.borderRadii.ellipse": "50%",
	"basics.borderRadii.pill": "1000em",
	"basics.borderWidths.none": "0",
	"basics.borderWidths.small": "1px",
	"basics.borderWidths.medium": "2px",
	"basics.borderWidths.large": "4px",
	"basics.colors.primary.black": "#000000",
	"basics.colors.primary.white": "#ffffff",
	"basics.colors.primary.autodeskBlue.100": "#cdeaf7",
	"basics.colors.primary.autodeskBlue.200": "#9bd5ef",
	"basics.colors.primary.autodeskBlue.300": "#6ac0e7",
	"basics.colors.primary.autodeskBlue.400": "#38abdf",
	"basics.colors.primary.autodeskBlue.500": "#0696d7",
	"basics.colors.primary.autodeskBlue.600": "#007fc6",
	"basics.colors.primary.autodeskBlue.700": "#006eaf",
	"basics.colors.primary.autodeskBlue.800": "#074b78",
	"basics.colors.primary.autodeskBlue.900": "#0a324d",
	"basics.colors.primary.charcoal.100": "#eeeeee",
	"basics.colors.primary.charcoal.200": "#dcdcdc",
	"basics.colors.primary.charcoal.300": "#cccccc",
	"basics.colors.primary.charcoal.400": "#bbbbbb",
	"basics.colors.primary.charcoal.500": "#999999",
	"basics.colors.primary.charcoal.600": "#808080",
	"basics.colors.primary.charcoal.700": "#666666",
	"basics.colors.primary.charcoal.800": "#4d4d4d",
	"basics.colors.primary.charcoal.900": "#3c3c3c",
	"basics.colors.secondary.darkBlue.100": "#e1ebf7",
	"basics.colors.secondary.darkBlue.200": "#bcd3ee",
	"basics.colors.secondary.darkBlue.300": "#8babdc",
	"basics.colors.secondary.darkBlue.400": "#5f8bcb",
	"basics.colors.secondary.darkBlue.500": "#3970b9",
	"basics.colors.secondary.darkBlue.600": "#1858a8",
	"basics.colors.secondary.darkBlue.700": "#064285",
	"basics.colors.secondary.darkBlue.800": "#003163",
	"basics.colors.secondary.darkBlue.900": "#0c2c54",
	"basics.colors.secondary.green.100": "#e7f2d9",
	"basics.colors.secondary.green.200": "#cfe4b3",
	"basics.colors.secondary.green.300": "#b7d78c",
	"basics.colors.secondary.green.400": "#9fc966",
	"basics.colors.secondary.green.500": "#87b340",
	"basics.colors.secondary.green.600": "#6a9728",
	"basics.colors.secondary.green.700": "#507b16",
	"basics.colors.secondary.green.800": "#385e08",
	"basics.colors.secondary.green.900": "#234200",
	"basics.colors.secondary.red.100": "#faeded",
	"basics.colors.secondary.red.200": "#f7d6d6",
	"basics.colors.secondary.red.300": "#f9b4b4",
	"basics.colors.secondary.red.400": "#f48686",
	"basics.colors.secondary.red.500": "#eb5555",
	"basics.colors.secondary.red.600": "#dd2222",
	"basics.colors.secondary.red.700": "#af1b1b",
	"basics.colors.secondary.red.800": "#800f0f",
	"basics.colors.secondary.red.900": "#520404",
	"basics.colors.secondary.turquoise.100": "#d6f2ef",
	"basics.colors.secondary.turquoise.200": "#ade4de",
	"basics.colors.secondary.turquoise.300": "#84d7ce",
	"basics.colors.secondary.turquoise.400": "#5bc9bd",
	"basics.colors.secondary.turquoise.500": "#32bcad",
	"basics.colors.secondary.turquoise.600": "#23a597",
	"basics.colors.secondary.turquoise.700": "#168576",
	"basics.colors.secondary.turquoise.800": "#0c665b",
	"basics.colors.secondary.turquoise.900": "#04403d",
	"basics.colors.secondary.yellowOrange.100": "#feecd1",
	"basics.colors.secondary.yellowOrange.200": "#fddaa4",
	"basics.colors.secondary.yellowOrange.300": "#fcc776",
	"basics.colors.secondary.yellowOrange.400": "#fbb549",
	"basics.colors.secondary.yellowOrange.500": "#faa21b",
	"basics.colors.secondary.yellowOrange.600": "#ed8d16",
	"basics.colors.secondary.yellowOrange.700": "#d9730b",
	"basics.colors.secondary.yellowOrange.800": "#bf5808",
	"basics.colors.secondary.yellowOrange.900": "#8c3401",
	"basics.colors.tertiary.pink.100": "#ffebf5",
	"basics.colors.tertiary.pink.200": "#ffd6eb",
	"basics.colors.tertiary.pink.300": "#ffb8db",
	"basics.colors.tertiary.pink.400": "#ff8cc6",
	"basics.colors.tertiary.pink.500": "#fc56a9",
	"basics.colors.tertiary.pink.600": "#e84396",
	"basics.colors.tertiary.pink.700": "#c72877",
	"basics.colors.tertiary.pink.800": "#991f5c",
	"basics.colors.tertiary.pink.900": "#781848",
	"basics.colors.tertiary.purple.100": "#f4edfd",
	"basics.colors.tertiary.purple.200": "#eadcfd",
	"basics.colors.tertiary.purple.300": "#d5bcf7",
	"basics.colors.tertiary.purple.400": "#c5a1f8",
	"basics.colors.tertiary.purple.500": "#b385f2",
	"basics.colors.tertiary.purple.600": "#a76ef5",
	"basics.colors.tertiary.purple.700": "#8558c5",
	"basics.colors.tertiary.purple.800": "#5f3e8e",
	"basics.colors.tertiary.purple.900": "#482f6b",
	"basics.colors.tertiary.salmon.100": "#ffefec",
	"basics.colors.tertiary.salmon.200": "#fcded9",
	"basics.colors.tertiary.salmon.300": "#ffbeb3",
	"basics.colors.tertiary.salmon.400": "#ff9582",
	"basics.colors.tertiary.salmon.500": "#f26a52",
	"basics.colors.tertiary.salmon.600": "#db5942",
	"basics.colors.tertiary.salmon.700": "#a84a39",
	"basics.colors.tertiary.salmon.800": "#853729",
	"basics.colors.tertiary.salmon.900": "#66251a",
	"basics.colors.tertiary.slate.100": "#e9f0f7",
	"basics.colors.tertiary.slate.200": "#dce7f3",
	"basics.colors.tertiary.slate.300": "#c1cedc",
	"basics.colors.tertiary.slate.400": "#a7bacf",
	"basics.colors.tertiary.slate.500": "#7993b0",
	"basics.colors.tertiary.slate.600": "#6784a6",
	"basics.colors.tertiary.slate.700": "#4b6b8f",
	"basics.colors.tertiary.slate.800": "#354d67",
	"basics.colors.tertiary.slate.900": "#2c3e53",
	"basics.colors.surface.lightGray.100": "#ffffff",
	"basics.colors.surface.lightGray.200": "#f5f5f5",
	"basics.colors.surface.lightGray.250": "#eeeeee",
	"basics.colors.surface.lightGray.300": "#d9d9d9",
	"basics.colors.surface.lightGray.350": "#cccccc",
	"basics.colors.surface.darkBlue.100": "#454f61",
	"basics.colors.surface.darkBlue.200": "#3b4453",
	"basics.colors.surface.darkBlue.250": "#2e3440",
	"basics.colors.surface.darkBlue.300": "#222933",
	"basics.colors.surface.darkBlue.350": "#1a1f25",
	"basics.colors.surface.darkGray.100": "#535353",
	"basics.colors.surface.darkGray.200": "#474747",
	"basics.colors.surface.darkGray.250": "#373737",
	"basics.colors.surface.darkGray.300": "#2a2a2a",
	"basics.colors.surface.darkGray.350": "#202020",
	"basics.colors.shadow.darkBlue": "rgba(26, 31, 38, 0.5)",
	"basics.colors.shadow.darkGray": "rgba(0, 0, 0, 0.3)",
	"basics.colors.shadow.lightGray": "rgba(0, 0, 0, 0.2)",
	"basics.colors.text.againstDark": "#f5f5f5",
	"basics.colors.text.againstLight": "#3c3c3c",
	"basics.colors.textLink.primary.againstLight": "#006eaf",
	"basics.colors.textLink.primary.againstDark": "#6dd2ff",
	"basics.colors.textLink.secondary.againstLight": "#3c3c3c",
	"basics.colors.textLink.secondary.againstDark": "#f5f5f5",
	"basics.colors.icon.lightGray": "#808080",
	"basics.colors.icon.darkBlue": "#a2a6b0",
	"basics.colors.icon.darkGray": "#999999",
	"basics.fontFamilies.main": "ArtifaktElement, sans-serif",
	"basics.fontFamilies.monospace": "'Source Code Pro', monospace",
	"basics.fontSizes.highSmall": "11px",
	"basics.fontSizes.highMedium": "12px",
	"basics.fontSizes.highLarge": "16px",
	"basics.fontSizes.highExtraLarge": "20px",
	"basics.fontSizes.highExtraExtraLarge": "24px",
	"basics.fontSizes.mediumSmall": "12px",
	"basics.fontSizes.mediumMedium": "14px",
	"basics.fontSizes.mediumLarge": "20px",
	"basics.fontSizes.mediumExtraLarge": "24px",
	"basics.fontSizes.mediumExtraExtraLarge": "28px",
	"basics.fontSizes.lowSmall": "14px",
	"basics.fontSizes.lowMedium": "16px",
	"basics.fontSizes.lowLarge": "22px",
	"basics.fontSizes.lowExtraLarge": "26px",
	"basics.fontSizes.lowExtraExtraLarge": "30px",
	"basics.fontWeights.regular": 400,
	"basics.fontWeights.medium": 600,
	"basics.fontWeights.bold": 700,
	"basics.lineHeights.small": "1.3",
	"basics.lineHeights.medium": "1.4",
	"basics.lineHeights.large": "1.5",
	"basics.lineHeights.highSmall": "1.25",
	"basics.lineHeights.highMedium": "1.272727273",
	"basics.lineHeights.highLarge": "1.3",
	"basics.lineHeights.highExtraLarge": "1.333333333",
	"basics.lineHeights.highExtraExtraLarge": "1.375",
	"basics.lineHeights.mediumSmall": "1.25",
	"basics.lineHeights.mediumMedium": "1.285714286",
	"basics.lineHeights.mediumLarge": "1.3",
	"basics.lineHeights.mediumExtraLarge": "1.428571429",
	"basics.lineHeights.mediumExtraExtraLarge": "1.5",
	"basics.shadows.lowBlur": "4px",
	"basics.shadows.highBlur": "16px",
	"basics.spacings.none": "0",
	"basics.spacings.highExtraExtraSmall": "2px",
	"basics.spacings.highExtraSmall": "4px",
	"basics.spacings.highSmall": "8px",
	"basics.spacings.highMedium": "12px",
	"basics.spacings.highLarge": "16px",
	"basics.spacings.highExtraLarge": "24px",
	"basics.spacings.highExtraExtraLarge": "32px",
	"basics.spacings.mediumExtraExtraSmall": "4px",
	"basics.spacings.mediumExtraSmall": "8px",
	"basics.spacings.mediumSmall": "12px",
	"basics.spacings.mediumMedium": "16px",
	"basics.spacings.mediumLarge": "24px",
	"basics.spacings.mediumExtraLarge": "32px",
	"basics.spacings.mediumExtraExtraLarge": "48px",
	"basics.spacings.lowExtraExtraSmall": "8px",
	"basics.spacings.lowExtraSmall": "12px",
	"basics.spacings.lowSmall": "16px",
	"basics.spacings.lowMedium": "24px",
	"basics.spacings.lowLarge": "32px",
	"basics.spacings.lowExtraLarge": "48px",
	"basics.spacings.lowExtraExtraLarge": "64px",
	"colorScheme.reference.accent": "#0696d7",
	"colorScheme.reference.base": "#808080",
	"colorScheme.surface.level100": "#ffffff",
	"colorScheme.surface.level200": "#f5f5f5",
	"colorScheme.surface.level250": "#eeeeee",
	"colorScheme.surface.level300": "#d9d9d9",
	"colorScheme.surface.level350": "#cccccc",
	"colorScheme.background.selected": "rgba(6, 150, 215, 0.15)",
	"colorScheme.background.on.default": "rgba(205, 234, 247, 0.6)",
	"colorScheme.background.on.hover": "rgba(155, 213, 239, 0.7)",
	"colorScheme.background.on.focus": "rgba(205, 234, 247, 0.6)",
	"colorScheme.background.on.pressed": "rgba(106, 192, 231, 0.7)",
	"colorScheme.background.empty.level100To250.hover": "rgba(128, 128, 128, 0.1)",
	"colorScheme.background.empty.level100To250.pressed": "rgba(128, 128, 128, 0.2)",
	"colorScheme.background.empty.level300To350.hover": "rgba(255, 255, 255, 0.25)",
	"colorScheme.background.empty.level300To350.pressed": "rgba(255, 255, 255, 0.35)",
	"colorScheme.background.filled.level100To250.default": "rgba(128, 128, 128, 0.15)",
	"colorScheme.background.filled.level100To250.hover": "rgba(128, 128, 128, 0.25)",
	"colorScheme.background.filled.level100To250.focus": "rgba(128, 128, 128, 0.15)",
	"colorScheme.background.filled.level100To250.pressed": "rgba(128, 128, 128, 0.35)",
	"colorScheme.background.filled.level300To350.default": "rgba(255, 255, 255, 0.5)",
	"colorScheme.background.filled.level300To350.hover": "rgba(255, 255, 255, 0.7)",
	"colorScheme.background.filled.level300To350.focus": "rgba(255, 255, 255, 0.5)",
	"colorScheme.background.filled.level300To350.pressed": "#ffffff",
	"colorScheme.background.transparent": "rgba(255, 255, 255, 0.01)",
	"colorScheme.border.base": "rgba(128, 128, 128, 0.5)",
	"colorScheme.border.accent": "#0696d7",
	"colorScheme.border.on": "rgba(6, 150, 215, 0.5)",
	"colorScheme.border.transparent": "rgba(128, 128, 128, 0)",
	"colorScheme.halo.hover": "rgba(128, 128, 128, 0.15)",
	"colorScheme.halo.focus": "rgba(6, 150, 215, 0.35)",
	"colorScheme.halo.pressed": "rgba(128, 128, 128, 0.25)",
	"colorScheme.shadow.high": "rgba(0, 0, 0, 0.2)",
	"colorScheme.shadow.low": "rgba(0, 0, 0, 0.2)",
	"colorScheme.text.default": "#3c3c3c",
	"colorScheme.text.dim": "rgba(60, 60, 60, 0.7)",
	"colorScheme.text.placeholder": "rgba(60, 60, 60, 0.4)",
	"colorScheme.text.active": "#0696d7",
	"colorScheme.icon.default": "#808080",
	"colorScheme.icon.hover": "#3c3c3c",
	"colorScheme.icon.focus": "#808080",
	"colorScheme.icon.pressed": "#3c3c3c",
	"colorScheme.icon.on.default": "#0696d7",
	"colorScheme.icon.on.hover": "#006eaf",
	"colorScheme.icon.on.focus": "#0696d7",
	"colorScheme.icon.on.pressed": "#006eaf",
	"colorScheme.indicator.default": "rgba(102, 102, 102, 0.7)",
	"colorScheme.indicator.hover": "#666666",
	"colorScheme.indicator.focus": "rgba(102, 102, 102, 0.7)",
	"colorScheme.indicator.pressed": "#3c3c3c",
	"colorScheme.indicator.on": "#0696d7",
	"colorScheme.status.error": "#dd2222",
	"colorScheme.status.success": "#6a9728",
	"colorScheme.status.warning": "#faa21b",
	"colorScheme.status.info": "#0696d7",
	"colorScheme.status.read": "rgba(128, 128, 128, 0.4)",
	"colorScheme.divider.lightweight": "rgba(60, 60, 60, 0.1)",
	"colorScheme.divider.heavyweight": "rgba(60, 60, 60, 0.25)",
	"colorScheme.opacity.mask": "#e84396",
	"colorScheme.opacity.disabled": 0.4,
	"density.spacings.extraExtraSmall": "4px",
	"density.spacings.extraSmall": "8px",
	"density.spacings.small": "12px",
	"density.spacings.medium": "16px",
	"density.spacings.large": "24px",
	"density.spacings.extraLarge": "32px",
	"density.spacings.extraExtraLarge": "48px",
	"density.fontSizes.small": "12px",
	"density.fontSizes.medium": "14px",
	"density.fontSizes.large": "20px",
	"density.fontSizes.extraLarge": "24px",
	"density.fontSizes.extraExtraLarge": "28px",
	"accordion.header.fontColor": "#3c3c3c",
	"accordion.header.fontFamily": "ArtifaktElement, sans-serif",
	"accordion.header.fontSize": "14px",
	"accordion.header.fontWeight": 700,
	"accordion.header.lineHeight": "1.428571429",
	"accordion.header.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"accordion.header.paddingHorizontal": "8px",
	"accordion.header.paddingVertical": "8px",
	"accordion.header.indicatorGutter": "8px",
	"accordion.header.indicatorSize": "16px",
	"accordion.header.default.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"accordion.header.hover.indicatorColor": "#666666",
	"accordion.header.indicatorRight.paddingLeft": "12px",
	"accordion.header.indicatorRight.paddingRight": "12px",
	"avatar.fontWeight": 400,
	"avatar.fontColor": "#ffffff",
	"avatar.extraSmall.fontSize": "11px",
	"avatar.extraSmall.diameter": "16px",
	"avatar.small.fontSize": "12px",
	"avatar.small.diameter": "24px",
	"avatar.medium.fontSize": "14px",
	"avatar.medium.diameter": "32px",
	"avatar.large.fontSize": "24px",
	"avatar.large.diameter": "48px",
	"avatar.extraLarge.fontSize": "30px",
	"avatar.extraLarge.diameter": "64px",
	"avatar.backgroundColor1": "#bc2b2b",
	"avatar.backgroundColor2": "#871616",
	"avatar.backgroundColor3": "#ce6d3c",
	"avatar.backgroundColor4": "#527c29",
	"avatar.backgroundColor5": "#1d6328",
	"avatar.backgroundColor6": "#298080",
	"avatar.backgroundColor7": "#23688a",
	"avatar.backgroundColor8": "#3d6ac2",
	"avatar.backgroundColor9": "#163b84",
	"avatar.backgroundColor10": "#5b5bc2",
	"avatar.backgroundColor11": "#571698",
	"avatar.backgroundColor12": "#801d94",
	"avatar.backgroundColor13": "#be29be",
	"avatar.backgroundColor14": "#8f1d69",
	"avatar.backgroundColor15": "#c84b75",
	"avatarBundle.fontColor": "#3c3c3c",
	"avatarBundle.default.backgroundColor": "#eeeeee",
	"avatarBundle.hover.backgroundColor": "#eeeeee",
	"avatarBundle.pressed.backgroundColor": "#eeeeee",
	"avatarBundle.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"avatarBundle.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"avatarBundle.hover.haloWidth": "2px",
	"avatarBundle.pressed.haloWidth": "4px",
	"avatarBundle.extraSmall.default.spacing.secondItem": "16px",
	"avatarBundle.extraSmall.default.spacing.thirdItem": "32px",
	"avatarBundle.small.default.spacing.secondItem": "20px",
	"avatarBundle.small.default.spacing.thirdItem": "40px",
	"avatarBundle.medium.default.spacing.secondItem": "28px",
	"avatarBundle.medium.default.spacing.thirdItem": "56px",
	"avatarBundle.large.default.spacing.secondItem": "44px",
	"avatarBundle.large.default.spacing.thirdItem": "88px",
	"avatarBundle.extraLarge.default.spacing.secondItem": "60px",
	"avatarBundle.extraLarge.default.spacing.thirdItem": "120px",
	"avatarBundle.extraSmall.condensed.spacing.secondItem": "12px",
	"avatarBundle.extraSmall.condensed.spacing.thirdItem": "24px",
	"avatarBundle.small.condensed.spacing.secondItem": "16px",
	"avatarBundle.small.condensed.spacing.thirdItem": "32px",
	"avatarBundle.medium.condensed.spacing.secondItem": "20px",
	"avatarBundle.medium.condensed.spacing.thirdItem": "40px",
	"avatarBundle.large.condensed.spacing.secondItem": "28px",
	"avatarBundle.large.condensed.spacing.thirdItem": "56px",
	"avatarBundle.extraLarge.condensed.spacing.secondItem": "40px",
	"avatarBundle.extraLarge.condensed.spacing.thirdItem": "80px",
	"avatarBundle.extraSmall.superCondensed.spacing.secondItem": "4px",
	"avatarBundle.extraSmall.superCondensed.spacing.thirdItem": "8px",
	"avatarBundle.small.superCondensed.spacing.secondItem": "8px",
	"avatarBundle.small.superCondensed.spacing.thirdItem": "16px",
	"avatarBundle.medium.superCondensed.spacing.secondItem": "12px",
	"avatarBundle.medium.superCondensed.spacing.thirdItem": "24px",
	"avatarBundle.large.superCondensed.spacing.secondItem": "16px",
	"avatarBundle.large.superCondensed.spacing.thirdItem": "32px",
	"avatarBundle.extraLarge.superCondensed.spacing.secondItem": "24px",
	"avatarBundle.extraLarge.superCondensed.spacing.thirdItem": "48px",
	"avatarBundle.extraSmall.border": "1px",
	"avatarBundle.small.border": "1px",
	"avatarBundle.medium.border": "2px",
	"avatarBundle.large.border": "2px",
	"avatarBundle.extraLarge.border": "4px",
	"badge.text.fontFamily": "ArtifaktElement, sans-serif",
	"badge.text.fontSize": "11px",
	"badge.text.fontWeight": 700,
	"badge.text.lineHeight": "1.25",
	"badge.text.padding.horizontal": "8px",
	"badge.text.cornerRadius": "1000em",
	"badge.text.minHeight": "20px",
	"badge.icon.cornerRadius": "50%",
	"badge.icon.large.minHeight": "28px",
	"badge.icon.small.minHeight": "20px",
	"badge.dot.cornerRadius": "50%",
	"badge.dot.large.minHeight": "12px",
	"badge.dot.small.minHeight": "8px",
	"badge.outline.borderWidth": "2px",
	"badge.outline.borderColor": "#ffffff",
	"badge.green.backgroundColor": "#6a9728",
	"badge.green.fontColor": "#ffffff",
	"badge.green.iconColor": "#ffffff",
	"badge.orange.backgroundColor": "#fe8d55",
	"badge.orange.fontColor": "#000000",
	"badge.orange.iconColor": "#ffffff",
	"badge.red.backgroundColor": "#dd2222",
	"badge.red.fontColor": "#ffffff",
	"badge.red.iconColor": "#ffffff",
	"badge.yellow.backgroundColor": "#faa21b",
	"badge.yellow.fontColor": "#000000",
	"badge.yellow.iconColor": "#ffffff",
	"banner.error.backgroundColor": "rgba(221, 34, 34, 0.2)",
	"banner.error.borderColor": "#f9b4b4",
	"banner.error.iconField.backgroundColor": "#dd2222",
	"banner.info.backgroundColor": "rgba(6, 150, 215, 0.2)",
	"banner.info.borderColor": "#9bd5ef",
	"banner.info.iconField.backgroundColor": "#0696d7",
	"banner.success.backgroundColor": "rgba(106, 151, 40, 0.2)",
	"banner.success.borderColor": "#b7d78c",
	"banner.success.iconField.backgroundColor": "#6a9728",
	"banner.warning.backgroundColor": "rgba(250, 162, 27, 0.2)",
	"banner.warning.borderColor": "#fcc776",
	"banner.warning.iconField.backgroundColor": "#faa21b",
	"breadcrumb.label.fontColor": "#3c3c3c",
	"breadcrumb.label.fontFamily": "ArtifaktElement, sans-serif",
	"breadcrumb.label.fontSize": "14px",
	"breadcrumb.label.default.fontWeight": 400,
	"breadcrumb.label.selected.fontWeight": 700,
	"breadcrumb.default.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"breadcrumb.selected.indicatorColor": "#0696d7",
	"breadcrumb.divider.fontColor": "rgba(60, 60, 60, 0.4)",
	"breadcrumb.divider.fontWeight": 600,
	"button.borderRadius": "2px",
	"button.borderWidth": "1px",
	"button.minWidth": "10px",
	"button.paddingHorizontal": "16px",
	"button.paddingVertical": "8px",
	"button.gutterWidth": "8px",
	"button.label.fontFamily": "ArtifaktElement, sans-serif",
	"button.label.fontSize": "14px",
	"button.label.fontWeight": 600,
	"button.label.lineHeight": "18px",
	"button.haloWidth": "2px",
	"button.hover.haloWidth": "2px",
	"button.pressed.haloWidth": "4px",
	"button.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"button.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"button.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"button.solid.label.fontColor": "#ffffff",
	"button.solid.iconColor": "#ffffff",
	"button.solid.indicatorColor": "#ffffff",
	"button.solid.default.backgroundColor": "#0696d7",
	"button.solid.hover.backgroundColor": "#0696d7",
	"button.solid.focus.backgroundColor": "#0696d7",
	"button.solid.pressed.backgroundColor": "#0696d7",
	"button.solid.default.borderColor": "#0696d7",
	"button.solid.hover.borderColor": "#0696d7",
	"button.solid.focus.borderColor": "#0696d7",
	"button.solid.pressed.borderColor": "#0696d7",
	"button.outline.label.fontColor": "#3c3c3c",
	"button.outline.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"button.outline.iconColor": "#808080",
	"button.outline.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.outline.hover.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.outline.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.outline.pressed.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.outline.default.borderColor": "rgba(128, 128, 128, 0.5)",
	"button.outline.hover.borderColor": "rgba(128, 128, 128, 0.5)",
	"button.outline.focus.borderColor": "#0696d7",
	"button.outline.pressed.borderColor": "rgba(128, 128, 128, 0.85)",
	"button.flat.label.fontColor": "#006eaf",
	"button.flat.iconColor": "#006eaf",
	"button.flat.indicatorColor": "#006eaf",
	"button.flat.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.hover.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.pressed.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.default.borderColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.hover.borderColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.focus.borderColor": "rgba(255, 255, 255, 0.01)",
	"button.flat.pressed.borderColor": "rgba(255, 255, 255, 0.01)",
	"button.segmented.label.fontColor": "#3c3c3c",
	"button.segmented.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"button.segmented.iconColor": "#808080",
	"button.segmented.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.segmented.hover.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.segmented.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"button.segmented.active.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"button.segmented.default.borderColor": "rgba(128, 128, 128, 0.5)",
	"button.segmented.hover.borderColor": "rgba(128, 128, 128, 0.5)",
	"button.segmented.focus.borderColor": "#0696d7",
	"button.segmented.active.borderColor": "rgba(6, 150, 215, 0.5)",
	"canvasFrame.label.fontColor": "#3c3c3c",
	"canvasFrame.label.fontFamily": "ArtifaktElement, sans-serif",
	"canvasFrame.label.fontSize": "14px",
	"canvasFrame.label.fontWeight": 600,
	"canvasFrame.label.marginLeft": "12px",
	"canvasFrame.border.borderColor": "#0696d7",
	"canvasFrame.border.borderWidth": "2px",
	"canvasFrame.controlPanel.backgroundColor": "#ffffff",
	"canvasFrame.controlPanel.paddingRight": "12px",
	"canvasFrame.controlPanel.paddingLeft": "8px",
	"canvasFrame.controlPanel.paddingVertical": "8px",
	"canvasFrame.closeIcon.marginLeft": "12px",
	"checkbox.borderWidth": "1px",
	"checkbox.borderRadius": "0",
	"checkbox.minHeight": "16px",
	"checkbox.indicatorColor": "#ffffff",
	"checkbox.minWidth": "16px",
	"checkbox.unchecked.default.backgroundColor": "#ffffff",
	"checkbox.unchecked.default.borderColor": "rgba(128, 128, 128, 0.5)",
	"checkbox.unchecked.hover.borderColor": "rgba(128, 128, 128, 0.5)",
	"checkbox.unchecked.focus.borderColor": "#0696d7",
	"checkbox.unchecked.pressed.borderColor": "rgba(128, 128, 128, 0.5)",
	"checkbox.checked.default.borderColor": "#808080",
	"checkbox.checked.default.backgroundColor": "#808080",
	"checkbox.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"checkbox.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"checkbox.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"checkbox.focus.haloWidth": "2px",
	"checkbox.hover.haloWidth": "2px",
	"checkbox.pressed.haloWidth": "4px",
	"checkbox.unchecked.hover.backgroundColor": "#ffffff",
	"checkbox.unchecked.focus.backgroundColor": "#ffffff",
	"checkbox.unchecked.pressed.backgroundColor": "#ffffff",
	"checkbox.checked.hover.backgroundColor": "#808080",
	"checkbox.checked.hover.borderColor": "#808080",
	"checkbox.checked.pressed.backgroundColor": "#808080",
	"checkbox.checked.pressed.borderColor": "#808080",
	"dataVis.colors.red.a.10": "#e7b1ba",
	"dataVis.colors.red.a.20": "#e09da8",
	"dataVis.colors.red.a.30": "#da8997",
	"dataVis.colors.red.a.40": "#d47686",
	"dataVis.colors.red.a.50": "#ce6274",
	"dataVis.colors.red.a.60": "#c84f63",
	"dataVis.colors.red.a.70": "#c23b52",
	"dataVis.colors.red.a.80": "#bc2840",
	"dataVis.colors.red.a.90": "#a31d33",
	"dataVis.colors.red.a.100": "#801628",
	"dataVis.colors.red.b.10": "#e7b2b2",
	"dataVis.colors.red.b.20": "#e09f9f",
	"dataVis.colors.red.b.30": "#da8c8c",
	"dataVis.colors.red.b.40": "#d47878",
	"dataVis.colors.red.b.50": "#ce6565",
	"dataVis.colors.red.b.60": "#c85252",
	"dataVis.colors.red.b.70": "#c23f3f",
	"dataVis.colors.red.b.80": "#bc2b2b",
	"dataVis.colors.red.b.90": "#ab1d1d",
	"dataVis.colors.red.b.100": "#871616",
	"dataVis.colors.red.c.10": "#e7b4a9",
	"dataVis.colors.red.c.20": "#e0a194",
	"dataVis.colors.red.c.30": "#da8e7f",
	"dataVis.colors.red.c.40": "#d47b69",
	"dataVis.colors.red.c.50": "#ce6854",
	"dataVis.colors.red.c.60": "#c8553f",
	"dataVis.colors.red.c.70": "#c24329",
	"dataVis.colors.red.c.80": "#a53823",
	"dataVis.colors.red.c.90": "#882e1d",
	"dataVis.colors.red.c.100": "#6b2516",
	"dataVis.colors.orange.a.10": "#f3dace",
	"dataVis.colors.orange.a.20": "#edc8b6",
	"dataVis.colors.orange.a.30": "#e7b69e",
	"dataVis.colors.orange.a.40": "#e0a485",
	"dataVis.colors.orange.a.50": "#da916d",
	"dataVis.colors.orange.a.60": "#d47f54",
	"dataVis.colors.orange.a.70": "#ce6d3c",
	"dataVis.colors.orange.a.80": "#bd5e2f",
	"dataVis.colors.orange.a.90": "#a45229",
	"dataVis.colors.orange.a.100": "#8b4623",
	"dataVis.colors.orange.b.10": "#f3dcc5",
	"dataVis.colors.orange.b.20": "#edcba9",
	"dataVis.colors.orange.b.30": "#e7b98c",
	"dataVis.colors.orange.b.40": "#e0a86f",
	"dataVis.colors.orange.b.50": "#da9652",
	"dataVis.colors.orange.b.60": "#d0863b",
	"dataVis.colors.orange.b.70": "#bb7835",
	"dataVis.colors.orange.b.80": "#a56a2f",
	"dataVis.colors.orange.b.90": "#905c29",
	"dataVis.colors.orange.b.100": "#7a4e23",
	"dataVis.colors.orange.c.10": "#f3dfb7",
	"dataVis.colors.orange.c.20": "#edcf93",
	"dataVis.colors.orange.c.30": "#e7bf6f",
	"dataVis.colors.orange.c.40": "#e0af4b",
	"dataVis.colors.orange.c.50": "#ce9f41",
	"dataVis.colors.orange.c.60": "#bb903b",
	"dataVis.colors.orange.c.70": "#a88235",
	"dataVis.colors.orange.c.80": "#94732f",
	"dataVis.colors.orange.c.90": "#816429",
	"dataVis.colors.orange.c.100": "#6e5523",
	"dataVis.colors.yellow.a.10": "#f9f2cd",
	"dataVis.colors.yellow.a.20": "#f3e49b",
	"dataVis.colors.yellow.a.30": "#edd768",
	"dataVis.colors.yellow.a.40": "#e0c84e",
	"dataVis.colors.yellow.a.50": "#cfb847",
	"dataVis.colors.yellow.a.60": "#bda841",
	"dataVis.colors.yellow.a.70": "#ab993b",
	"dataVis.colors.yellow.a.80": "#9a8935",
	"dataVis.colors.yellow.a.90": "#88792f",
	"dataVis.colors.yellow.a.100": "#766929",
	"dataVis.colors.yellow.b.10": "#f9f9a5",
	"dataVis.colors.yellow.b.20": "#f1f15a",
	"dataVis.colors.yellow.b.30": "#e1e154",
	"dataVis.colors.yellow.b.40": "#d0d04e",
	"dataVis.colors.yellow.b.50": "#c0c047",
	"dataVis.colors.yellow.b.60": "#afaf41",
	"dataVis.colors.yellow.b.70": "#9f9f3b",
	"dataVis.colors.yellow.b.80": "#8e8e35",
	"dataVis.colors.yellow.b.90": "#7e7e2f",
	"dataVis.colors.yellow.b.100": "#6e6e29",
	"dataVis.colors.yellowGreen.a.10": "#e0f380",
	"dataVis.colors.yellowGreen.a.20": "#d0e954",
	"dataVis.colors.yellowGreen.a.30": "#c1d84e",
	"dataVis.colors.yellowGreen.a.40": "#b2c747",
	"dataVis.colors.yellowGreen.a.50": "#a2b641",
	"dataVis.colors.yellowGreen.a.60": "#93a53b",
	"dataVis.colors.yellowGreen.a.70": "#849435",
	"dataVis.colors.yellowGreen.a.80": "#75832f",
	"dataVis.colors.yellowGreen.a.90": "#667229",
	"dataVis.colors.yellowGreen.a.100": "#566123",
	"dataVis.colors.yellowGreen.b.10": "#d6f39b",
	"dataVis.colors.yellowGreen.b.20": "#c1ed6a",
	"dataVis.colors.yellowGreen.b.30": "#b0e14e",
	"dataVis.colors.yellowGreen.b.40": "#a2cf47",
	"dataVis.colors.yellowGreen.b.50": "#94bd41",
	"dataVis.colors.yellowGreen.b.60": "#86ab3b",
	"dataVis.colors.yellowGreen.b.70": "#789a35",
	"dataVis.colors.yellowGreen.b.80": "#6a882f",
	"dataVis.colors.yellowGreen.b.90": "#5c7629",
	"dataVis.colors.yellowGreen.b.100": "#4f6523",
	"dataVis.colors.yellowGreen.c.10": "#cff3ac",
	"dataVis.colors.yellowGreen.c.20": "#b8ed83",
	"dataVis.colors.yellowGreen.c.30": "#a0e759",
	"dataVis.colors.yellowGreen.c.40": "#90d847",
	"dataVis.colors.yellowGreen.c.50": "#83c641",
	"dataVis.colors.yellowGreen.c.60": "#77b33b",
	"dataVis.colors.yellowGreen.c.70": "#6ba135",
	"dataVis.colors.yellowGreen.c.80": "#5e8e2f",
	"dataVis.colors.yellowGreen.c.90": "#527c29",
	"dataVis.colors.yellowGreen.c.100": "#466923",
	"dataVis.colors.green.a.10": "#b1ed94",
	"dataVis.colors.green.a.20": "#98e770",
	"dataVis.colors.green.a.30": "#7ee04c",
	"dataVis.colors.green.a.40": "#71cf41",
	"dataVis.colors.green.a.50": "#66bc3b",
	"dataVis.colors.green.a.60": "#5ba835",
	"dataVis.colors.green.a.70": "#51952f",
	"dataVis.colors.green.a.80": "#468129",
	"dataVis.colors.green.a.90": "#3c6e23",
	"dataVis.colors.green.a.100": "#315b1d",
	"dataVis.colors.green.b.10": "#adeda0",
	"dataVis.colors.green.b.20": "#92e781",
	"dataVis.colors.green.b.30": "#76e061",
	"dataVis.colors.green.b.40": "#5bda41",
	"dataVis.colors.green.b.50": "#52c63b",
	"dataVis.colors.green.b.60": "#4ab135",
	"dataVis.colors.green.b.70": "#419d2f",
	"dataVis.colors.green.b.80": "#398829",
	"dataVis.colors.green.b.90": "#307423",
	"dataVis.colors.green.b.100": "#285f1d",
	"dataVis.colors.green.c.10": "#a9eda9",
	"dataVis.colors.green.c.20": "#8de78d",
	"dataVis.colors.green.c.30": "#70e070",
	"dataVis.colors.green.c.40": "#54da54",
	"dataVis.colors.green.c.50": "#3bd23b",
	"dataVis.colors.green.c.60": "#35bc35",
	"dataVis.colors.green.c.70": "#2fa62f",
	"dataVis.colors.green.c.80": "#299129",
	"dataVis.colors.green.c.90": "#237b23",
	"dataVis.colors.green.c.100": "#1d651d",
	"dataVis.colors.blueGreen.a.10": "#a6edb2",
	"dataVis.colors.blueGreen.a.20": "#89e798",
	"dataVis.colors.blueGreen.a.30": "#6be07f",
	"dataVis.colors.blueGreen.a.40": "#4eda65",
	"dataVis.colors.blueGreen.a.50": "#3bcd53",
	"dataVis.colors.blueGreen.a.60": "#35b84b",
	"dataVis.colors.blueGreen.a.70": "#2fa342",
	"dataVis.colors.blueGreen.a.80": "#298d3a",
	"dataVis.colors.blueGreen.a.90": "#237831",
	"dataVis.colors.blueGreen.a.100": "#1d6328",
	"dataVis.colors.blueGreen.b.10": "#a3edbb",
	"dataVis.colors.blueGreen.b.20": "#84e7a5",
	"dataVis.colors.blueGreen.b.30": "#65e08e",
	"dataVis.colors.blueGreen.b.40": "#47da78",
	"dataVis.colors.blueGreen.b.50": "#3bc96a",
	"dataVis.colors.blueGreen.b.60": "#35b45f",
	"dataVis.colors.blueGreen.b.70": "#2f9f54",
	"dataVis.colors.blueGreen.b.80": "#298a49",
	"dataVis.colors.blueGreen.b.90": "#23763e",
	"dataVis.colors.blueGreen.b.100": "#1d6133",
	"dataVis.colors.blueGreen.c.10": "#9fedc6",
	"dataVis.colors.blueGreen.c.20": "#7fe7b3",
	"dataVis.colors.blueGreen.c.30": "#5fe0a0",
	"dataVis.colors.blueGreen.c.40": "#41d98d",
	"dataVis.colors.blueGreen.c.50": "#3bc580",
	"dataVis.colors.blueGreen.c.60": "#35b073",
	"dataVis.colors.blueGreen.c.70": "#2f9c65",
	"dataVis.colors.blueGreen.c.80": "#298858",
	"dataVis.colors.blueGreen.c.90": "#23734b",
	"dataVis.colors.blueGreen.c.100": "#1d5f3e",
	"dataVis.colors.cyan.a.10": "#9bedd1",
	"dataVis.colors.cyan.a.20": "#79e7c2",
	"dataVis.colors.cyan.a.30": "#58e0b3",
	"dataVis.colors.cyan.a.40": "#41d5a4",
	"dataVis.colors.cyan.a.50": "#3bc194",
	"dataVis.colors.cyan.a.60": "#35ad85",
	"dataVis.colors.cyan.a.70": "#2f9976",
	"dataVis.colors.cyan.a.80": "#298566",
	"dataVis.colors.cyan.a.90": "#237157",
	"dataVis.colors.cyan.a.100": "#1d5d48",
	"dataVis.colors.cyan.b.10": "#96edde",
	"dataVis.colors.cyan.b.20": "#73e7d3",
	"dataVis.colors.cyan.b.30": "#50e0c8",
	"dataVis.colors.cyan.b.40": "#41d1b9",
	"dataVis.colors.cyan.b.50": "#3bbda8",
	"dataVis.colors.cyan.b.60": "#35aa96",
	"dataVis.colors.cyan.b.70": "#2f9685",
	"dataVis.colors.cyan.b.80": "#298374",
	"dataVis.colors.cyan.b.90": "#236f62",
	"dataVis.colors.cyan.b.100": "#1d5b51",
	"dataVis.colors.cyan.c.10": "#91eded",
	"dataVis.colors.cyan.c.20": "#6ce7e7",
	"dataVis.colors.cyan.c.30": "#47e0e0",
	"dataVis.colors.cyan.c.40": "#41cdcd",
	"dataVis.colors.cyan.c.50": "#3bbaba",
	"dataVis.colors.cyan.c.60": "#35a7a7",
	"dataVis.colors.cyan.c.70": "#2f9393",
	"dataVis.colors.cyan.c.80": "#298080",
	"dataVis.colors.cyan.c.90": "#236d6d",
	"dataVis.colors.cyan.c.100": "#1d5a5a",
	"dataVis.colors.blueCyan.a.10": "#a8e1ed",
	"dataVis.colors.blueCyan.a.20": "#8ad7e7",
	"dataVis.colors.blueCyan.a.30": "#6dcde0",
	"dataVis.colors.blueCyan.a.40": "#50c3da",
	"dataVis.colors.blueCyan.a.50": "#3bb6cf",
	"dataVis.colors.blueCyan.a.60": "#35a3b9",
	"dataVis.colors.blueCyan.a.70": "#2f90a4",
	"dataVis.colors.blueCyan.a.80": "#297e8f",
	"dataVis.colors.blueCyan.a.90": "#236b79",
	"dataVis.colors.blueCyan.a.100": "#1d5864",
	"dataVis.colors.blueCyan.b.10": "#b5daed",
	"dataVis.colors.blueCyan.b.20": "#9dcee7",
	"dataVis.colors.blueCyan.b.30": "#84c2e0",
	"dataVis.colors.blueCyan.b.40": "#6bb5da",
	"dataVis.colors.blueCyan.b.50": "#53a9d4",
	"dataVis.colors.blueCyan.b.60": "#3a9dce",
	"dataVis.colors.blueCyan.b.70": "#2f8cbb",
	"dataVis.colors.blueCyan.b.80": "#297aa2",
	"dataVis.colors.blueCyan.b.90": "#23688a",
	"dataVis.colors.blueCyan.b.100": "#1d5572",
	"dataVis.colors.blueCyan.c.10": "#bed5ed",
	"dataVis.colors.blueCyan.c.20": "#a9c8e7",
	"dataVis.colors.blueCyan.c.30": "#93bae0",
	"dataVis.colors.blueCyan.c.40": "#7eacda",
	"dataVis.colors.blueCyan.c.50": "#689ed4",
	"dataVis.colors.blueCyan.c.60": "#5390ce",
	"dataVis.colors.blueCyan.c.70": "#3d82c8",
	"dataVis.colors.blueCyan.c.80": "#2974c0",
	"dataVis.colors.blueCyan.c.90": "#2363a3",
	"dataVis.colors.blueCyan.c.100": "#1d5186",
	"dataVis.colors.blue.a.10": "#b2c3e7",
	"dataVis.colors.blue.a.20": "#9eb4e0",
	"dataVis.colors.blue.a.30": "#8ba5da",
	"dataVis.colors.blue.a.40": "#7796d4",
	"dataVis.colors.blue.a.50": "#6487ce",
	"dataVis.colors.blue.a.60": "#5178c8",
	"dataVis.colors.blue.a.70": "#3d6ac2",
	"dataVis.colors.blue.a.80": "#2a5bbc",
	"dataVis.colors.blue.a.90": "#1d4ba8",
	"dataVis.colors.blue.a.100": "#163b84",
	"dataVis.colors.blue.b.10": "#b8c0e7",
	"dataVis.colors.blue.b.20": "#a6b0e0",
	"dataVis.colors.blue.b.30": "#95a0da",
	"dataVis.colors.blue.b.40": "#8391d4",
	"dataVis.colors.blue.b.50": "#7181ce",
	"dataVis.colors.blue.b.60": "#6071c8",
	"dataVis.colors.blue.b.70": "#4e61c2",
	"dataVis.colors.blue.b.80": "#3c51bc",
	"dataVis.colors.blue.b.90": "#2a42b6",
	"dataVis.colors.blue.b.100": "#1932af",
	"dataVis.colors.blue.c.10": "#bdbde7",
	"dataVis.colors.blue.c.20": "#adade0",
	"dataVis.colors.blue.c.30": "#9c9cda",
	"dataVis.colors.blue.c.40": "#8c8cd4",
	"dataVis.colors.blue.c.50": "#7c7cce",
	"dataVis.colors.blue.c.60": "#6b6bc8",
	"dataVis.colors.blue.c.70": "#5b5bc2",
	"dataVis.colors.blue.c.80": "#4a4abc",
	"dataVis.colors.blue.c.90": "#3a3ab6",
	"dataVis.colors.blue.c.100": "#2929af",
	"dataVis.colors.purple.a.10": "#c2bbe7",
	"dataVis.colors.purple.a.20": "#b3aae0",
	"dataVis.colors.purple.a.30": "#a499da",
	"dataVis.colors.purple.a.40": "#9488d4",
	"dataVis.colors.purple.a.50": "#8577ce",
	"dataVis.colors.purple.a.60": "#7666c8",
	"dataVis.colors.purple.a.70": "#6755c2",
	"dataVis.colors.purple.a.80": "#5843bc",
	"dataVis.colors.purple.a.90": "#4832b6",
	"dataVis.colors.purple.a.100": "#3921af",
	"dataVis.colors.purple.b.10": "#c8b8e7",
	"dataVis.colors.purple.b.20": "#baa6e0",
	"dataVis.colors.purple.b.30": "#ac95da",
	"dataVis.colors.purple.b.40": "#9e83d4",
	"dataVis.colors.purple.b.50": "#9071ce",
	"dataVis.colors.purple.b.60": "#825fc8",
	"dataVis.colors.purple.b.70": "#744ec2",
	"dataVis.colors.purple.b.80": "#663cbc",
	"dataVis.colors.purple.b.90": "#592ab6",
	"dataVis.colors.purple.b.100": "#4b18af",
	"dataVis.colors.purple.c.10": "#ceb5e7",
	"dataVis.colors.purple.c.20": "#c1a2e0",
	"dataVis.colors.purple.c.30": "#b590da",
	"dataVis.colors.purple.c.40": "#a97dd4",
	"dataVis.colors.purple.c.50": "#9c6bce",
	"dataVis.colors.purple.c.60": "#9058c8",
	"dataVis.colors.purple.c.70": "#8446c2",
	"dataVis.colors.purple.c.80": "#7733bc",
	"dataVis.colors.purple.c.90": "#6b21b6",
	"dataVis.colors.purple.c.100": "#571698",
	"dataVis.colors.magenta.a.10": "#dfc5ed",
	"dataVis.colors.magenta.a.20": "#d5b1e7",
	"dataVis.colors.magenta.a.30": "#ca9ee0",
	"dataVis.colors.magenta.a.40": "#c08ada",
	"dataVis.colors.magenta.a.50": "#b577d4",
	"dataVis.colors.magenta.a.60": "#ab64ce",
	"dataVis.colors.magenta.a.70": "#a050c8",
	"dataVis.colors.magenta.a.80": "#953dc2",
	"dataVis.colors.magenta.a.90": "#8b29bc",
	"dataVis.colors.magenta.a.100": "#791da7",
	"dataVis.colors.magenta.b.10": "#e5c2ed",
	"dataVis.colors.magenta.b.20": "#ddade7",
	"dataVis.colors.magenta.b.30": "#d499e0",
	"dataVis.colors.magenta.b.40": "#cc84da",
	"dataVis.colors.magenta.b.50": "#c370d4",
	"dataVis.colors.magenta.b.60": "#bb5bce",
	"dataVis.colors.magenta.b.70": "#b247c8",
	"dataVis.colors.magenta.b.80": "#aa32c2",
	"dataVis.colors.magenta.b.90": "#9b23b3",
	"dataVis.colors.magenta.b.100": "#801d94",
	"dataVis.colors.magenta.c.10": "#edbeed",
	"dataVis.colors.magenta.c.20": "#e7a8e7",
	"dataVis.colors.magenta.c.30": "#e093e0",
	"dataVis.colors.magenta.c.40": "#da7dda",
	"dataVis.colors.magenta.c.50": "#d467d4",
	"dataVis.colors.magenta.c.60": "#ce52ce",
	"dataVis.colors.magenta.c.70": "#c83cc8",
	"dataVis.colors.magenta.c.80": "#be29be",
	"dataVis.colors.magenta.c.90": "#a223a2",
	"dataVis.colors.magenta.c.100": "#851d85",
	"dataVis.colors.rose.a.10": "#edbfe5",
	"dataVis.colors.rose.a.20": "#e7aadc",
	"dataVis.colors.rose.a.30": "#e095d4",
	"dataVis.colors.rose.a.40": "#da80cb",
	"dataVis.colors.rose.a.50": "#d46bc3",
	"dataVis.colors.rose.a.60": "#ce55ba",
	"dataVis.colors.rose.a.70": "#c840b1",
	"dataVis.colors.rose.a.80": "#c22ba9",
	"dataVis.colors.rose.a.90": "#a72391",
	"dataVis.colors.rose.a.100": "#8a1d78",
	"dataVis.colors.rose.b.10": "#edc1de",
	"dataVis.colors.rose.b.20": "#e7acd3",
	"dataVis.colors.rose.b.30": "#e097c8",
	"dataVis.colors.rose.b.40": "#da82bd",
	"dataVis.colors.rose.b.50": "#d46eb2",
	"dataVis.colors.rose.b.60": "#ce59a7",
	"dataVis.colors.rose.b.70": "#c8449c",
	"dataVis.colors.rose.b.80": "#c22f91",
	"dataVis.colors.rose.b.90": "#ae2380",
	"dataVis.colors.rose.b.100": "#8f1d69",
	"dataVis.colors.rose.c.10": "#edc2d7",
	"dataVis.colors.rose.c.20": "#e7aeca",
	"dataVis.colors.rose.c.30": "#e099bd",
	"dataVis.colors.rose.c.40": "#da85b0",
	"dataVis.colors.rose.c.50": "#d471a2",
	"dataVis.colors.rose.c.60": "#ce5c95",
	"dataVis.colors.rose.c.70": "#c84888",
	"dataVis.colors.rose.c.80": "#c2337b",
	"dataVis.colors.rose.c.90": "#b5236c",
	"dataVis.colors.rose.c.100": "#951d59",
	"dataVis.colors.rose.d.10": "#edc3d1",
	"dataVis.colors.rose.d.20": "#e7afc2",
	"dataVis.colors.rose.d.30": "#e09bb2",
	"dataVis.colors.rose.d.40": "#da87a3",
	"dataVis.colors.rose.d.50": "#d47394",
	"dataVis.colors.rose.d.60": "#ce5f84",
	"dataVis.colors.rose.d.70": "#c84b75",
	"dataVis.colors.rose.d.80": "#c23766",
	"dataVis.colors.rose.d.90": "#bc2356",
	"dataVis.colors.rose.d.100": "#9c1d47",
	"dataVis.colors.gray.a.10": "#e1e1dc",
	"dataVis.colors.gray.a.20": "#d2d2cd",
	"dataVis.colors.gray.a.30": "#c2c2be",
	"dataVis.colors.gray.a.40": "#b3b3af",
	"dataVis.colors.gray.a.50": "#a4a4a0",
	"dataVis.colors.gray.a.60": "#949491",
	"dataVis.colors.gray.a.70": "#858582",
	"dataVis.colors.gray.a.80": "#767673",
	"dataVis.colors.gray.a.90": "#666664",
	"dataVis.colors.gray.a.100": "#575755",
	"dataVis.colors.gray.b.10": "#e0e0e1",
	"dataVis.colors.gray.b.20": "#d1d1d3",
	"dataVis.colors.gray.b.30": "#c2c2c4",
	"dataVis.colors.gray.b.40": "#b2b2b5",
	"dataVis.colors.gray.b.50": "#a3a3a6",
	"dataVis.colors.gray.b.60": "#939397",
	"dataVis.colors.gray.b.70": "#848488",
	"dataVis.colors.gray.b.80": "#75757a",
	"dataVis.colors.gray.b.90": "#65656b",
	"dataVis.colors.gray.b.100": "#56565c",
	"dataVis.colors.gray.c.10": "#e0e0e0",
	"dataVis.colors.gray.c.20": "#d1d1d1",
	"dataVis.colors.gray.c.30": "#c2c2c2",
	"dataVis.colors.gray.c.40": "#b2b2b2",
	"dataVis.colors.gray.c.50": "#a3a3a3",
	"dataVis.colors.gray.c.60": "#949494",
	"dataVis.colors.gray.c.70": "#858585",
	"dataVis.colors.gray.c.80": "#757575",
	"dataVis.colors.gray.c.90": "#666666",
	"dataVis.colors.gray.c.100": "#575757",
	"datePicker.fontFamily": "ArtifaktElement, sans-serif",
	"datePicker.container.paddingHorizontal": "16px",
	"datePicker.container.paddingVertical": "24px",
	"datePicker.cell.minHeight": "36px",
	"datePicker.cell.minWidth": "36px",
	"datePicker.standardDate.fontColor": "#3c3c3c",
	"datePicker.standardDate.fontSize": "14px",
	"datePicker.standardDate.fontWeight": 400,
	"datePicker.selectedDate.fontWeight": 600,
	"datePicker.selectedDate.fontColor": "#ffffff",
	"datePicker.selectedDate.fontSize": "14px",
	"datePicker.notableDate.fontWeight": 400,
	"datePicker.notableDate.fontColor": "#0696d7",
	"datePicker.notableDate.fontSize": "14px",
	"datePicker.restrictedDate.fontWeight": 400,
	"datePicker.restrictedDate.fontColor": "rgba(60, 60, 60, 0.4)",
	"datePicker.restrictedDate.fontSize": "14px",
	"datePicker.day.fontWeight": 400,
	"datePicker.day.fontColor": "#3c3c3c",
	"datePicker.day.fontSize": "14px",
	"datePicker.header.fontWeight": 600,
	"datePicker.header.fontColor": "#3c3c3c",
	"datePicker.header.fontSize": "20px",
	"datePicker.header.paddingBottom": "24px",
	"datePicker.cell.borderColor": "#eeeeee",
	"datePicker.cell.borderWidth": "1px",
	"datePicker.standardDateCell.default.backgroundColor": "#ffffff",
	"datePicker.standardDateCell.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"datePicker.standardDateCell.focus.backgroundColor": "#ffffff",
	"datePicker.standardDateCell.focus.borderColor": "#0696d7",
	"datePicker.standardDateCell.focus.borderWidth": "1px",
	"datePicker.standardDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"datePicker.standardDateCell.focus.haloWidth": "2px",
	"datePicker.standardDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"datePicker.selectedDateCell.default.backgroundColor": "#0696d7",
	"datePicker.selectedDateCell.focus.backgroundColor": "#0696d7",
	"datePicker.selectedDateCell.focus.haloColor": "rgba(60, 60, 60, 0.25)",
	"datePicker.selectedDateCell.focus.haloWidth": "2px",
	"datePicker.rangeDateCell.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"datePicker.rangeDateCell.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"datePicker.rangeDateCell.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"datePicker.rangeDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"datePicker.rangeDateCell.focus.haloWidth": "2px",
	"datePicker.rangeDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"datePicker.currentDateCell.default.backgroundColor": "#ffffff",
	"datePicker.currentDateCell.default.borderColor": "#0696d7",
	"datePicker.currentDateCell.default.borderWidth": "1px",
	"datePicker.currentDateCell.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"datePicker.currentDateCell.hover.borderColor": "#0696d7",
	"datePicker.currentDateCell.hover.borderWidth": "1px",
	"datePicker.currentDateCell.focus.backgroundColor": "#ffffff",
	"datePicker.currentDateCell.focus.borderColor": "#0696d7",
	"datePicker.currentDateCell.focus.borderWidth": "1px",
	"datePicker.currentDateCell.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"datePicker.currentDateCell.focus.haloWidth": "2px",
	"datePicker.currentDateCell.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"datePicker.currentDateCell.pressed.borderColor": "#0696d7",
	"datePicker.currentDateCell.pressed.borderWidth": "1px",
	"divider.borderWidth": "1px",
	"divider.lightColor": "rgba(60, 60, 60, 0.1)",
	"divider.heavyColor": "rgba(60, 60, 60, 0.25)",
	"emptyState.text.fontFamily": "ArtifaktElement, sans-serif",
	"emptyState.text.fontColor": "#3c3c3c",
	"emptyState.text.headline.fontSize": "28px",
	"emptyState.text.tagline.fontSize": "20px",
	"emptyState.text.supportingText.fontSize": "14px",
	"emptyState.text.headline.fontWeight": 400,
	"emptyState.text.tagline.fontWeight": 600,
	"emptyState.text.supportingText.fontWeight": 400,
	"emptyState.text.headline.lineHeight": "1.285714286",
	"emptyState.text.tagline.lineHeight": "1.3",
	"emptyState.text.supportingText.lineHeight": "1.428571429",
	"emptyState.text.headline.paddingBottom": "48px",
	"emptyState.text.tagline.paddingTop": "48px",
	"emptyState.text.supportingText.paddingTop": "0",
	"emptyState.button.paddingTop": "32px",
	"emptyState.image.height": "150px",
	"emptyState.image.width": "266px",
	"emptyState.maxWidth": "700px",
	"flyout.backgroundColor": "#ffffff",
	"flyout.borderColor": "rgba(255, 255, 255, 0.01)",
	"flyout.borderRadius": "4px",
	"flyout.shadowBlur": "16px",
	"flyout.shadowColor": "rgba(0, 0, 0, 0.2)",
	"flyout.nub.hypotenuseLength": "16px",
	"illustration.colors.100": "#ffffff",
	"illustration.colors.200": "#f5f8fa",
	"illustration.colors.300": "#e6edf0",
	"illustration.colors.400": "#dee7ec",
	"illustration.colors.500": "#ccd9e0",
	"illustration.colors.600": "#b0c4ce",
	"illustration.colors.700": "#8ca9b8",
	"illustration.colors.800": "#5a7d91",
	"illustration.colors.outline": "#5a7d91",
	"iconButton.borderRadius": "2px",
	"iconButton.borderWidth": "0",
	"iconButton.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"iconButton.focus.haloWidth": "2px",
	"iconButton.dynamic.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.dynamic.hover.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.dynamic.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.dynamic.default.iconColor": "#808080",
	"iconButton.dynamic.hover.iconColor": "#3c3c3c",
	"iconButton.dynamic.focus.iconColor": "#808080",
	"iconButton.dynamic.pressed.iconColor": "#3c3c3c",
	"iconButton.dynamic.on.default.iconColor": "#0696d7",
	"iconButton.dynamic.on.hover.iconColor": "#006eaf",
	"iconButton.dynamic.on.focus.iconColor": "#0696d7",
	"iconButton.dynamic.on.pressed.iconColor": "#006eaf",
	"iconButton.dynamic.pressed.100To250BackgroundColor": "rgba(128, 128, 128, 0.2)",
	"iconButton.dynamic.pressed.300To350BackgroundColor": "rgba(255, 255, 255, 0.35)",
	"iconButton.static.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.default.borderColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.hover.borderColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.focus.borderColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.pressed.borderColor": "rgba(255, 255, 255, 0.01)",
	"iconButton.static.on.default.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"iconButton.static.on.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"iconButton.static.on.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"iconButton.static.on.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
	"iconButton.static.on.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"iconButton.static.on.hover.borderColor": "rgba(6, 150, 215, 0.5)",
	"iconButton.static.on.focus.borderColor": "#0696d7",
	"iconButton.static.on.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
	"iconButton.static.hover.100To250BackgroundColor": "rgba(128, 128, 128, 0.1)",
	"iconButton.static.pressed.100To250BackgroundColor": "rgba(128, 128, 128, 0.2)",
	"iconButton.static.hover.300To350BackgroundColor": "rgba(255, 255, 255, 0.25)",
	"iconButton.static.pressed.300To350BackgroundColor": "rgba(255, 255, 255, 0.35)",
	"iconButton.static.on.hover.100To250BackgroundColor": "rgba(6, 150, 215, 0.35)",
	"iconButton.static.on.hover.300To350BackgroundColor": "rgba(6, 150, 215, 0.35)",
	"input.borderWidth": "1px",
	"input.borderBottomWidth": "1px",
	"input.borderColor": "rgba(128, 128, 128, 0.2)",
	"input.borderRadius": "0",
	"input.haloWidth": "4px",
	"input.minHeight": "36px",
	"input.paddingVertical": "4px",
	"input.gutterWidth": "8px",
	"input.disabled.opacity": 0.4,
	"input.error.borderBottomColor": "#dd2222",
	"input.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"input.focus.haloColor": "rgba(6, 150, 215, 0.25)",
	"input.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"input.value.fontColor": "#3c3c3c",
	"input.value.fontFamily": "ArtifaktElement, sans-serif",
	"input.value.fontSize": "14px",
	"input.value.fontWeight": 600,
	"input.value.highlightColor": "rgba(6, 150, 215, 0.2)",
	"input.value.lineHeight": "1.4",
	"input.value.placeholderFontColor": "rgba(60, 60, 60, 0.4)",
	"input.indicator.default": "rgba(102, 102, 102, 0.7)",
	"input.indicator.focus": "rgba(102, 102, 102, 0.7)",
	"input.indicator.hover": "#666666",
	"input.indicator.pressed": "#3c3c3c",
	"input.line.paddingHorizontal": "0",
	"input.line.default.borderBottomColor": "rgba(128, 128, 128, 0.35)",
	"input.line.hover.borderBottomColor": "#808080",
	"input.line.focus.borderBottomColor": "#0696d7",
	"input.line.pressed.borderBottomColor": "rgba(128, 128, 128, 0.85)",
	"input.box.paddingHorizontal": "12px",
	"input.box.default.backgroundColor": "#ffffff",
	"input.box.hover.backgroundColor": "#ffffff",
	"input.box.focus.backgroundColor": "#ffffff",
	"input.box.pressed.backgroundColor": "#ffffff",
	"input.box.default.borderColor": "rgba(128, 128, 128, 0.2)",
	"input.box.hover.borderColor": "rgba(128, 128, 128, 0.2)",
	"input.box.focus.borderColor": "rgba(128, 128, 128, 0.2)",
	"input.box.pressed.borderColor": "rgba(128, 128, 128, 0.2)",
	"input.box.default.borderBottomColor": "rgba(255, 255, 255, 0.2)",
	"input.box.hover.borderBottomColor": "#808080",
	"input.box.focus.borderBottomColor": "#0696d7",
	"input.box.pressed.borderBottomColor": "rgba(128, 128, 128, 0.85)",
	"input.textArea.line.borderColor": "rgba(128, 128, 128, 0.2)",
	"label.fontFamily": "ArtifaktElement, sans-serif",
	"label.fontSize": "14px",
	"label.fontColor": "rgba(60, 60, 60, 0.9)",
	"label.hover.fontColor": "rgba(60, 60, 60, 0.9)",
	"label.fontWeight": 400,
	"label.lineHeight": "1.4",
	"label.top.fontSize": "12px",
	"menu.backgroundColor": "#ffffff",
	"menu.fontFamily": "ArtifaktElement, sans-serif",
	"menu.borderRadius": "0",
	"menu.topFlushBorderTopRadius": "0",
	"menu.container.paddingVertical": "8px",
	"menu.divider.backgroundColor": "rgba(60, 60, 60, 0.1)",
	"menu.divider.paddingVertical": "12px",
	"menu.header.fontSize": "12px",
	"menu.header.fontWeight": 700,
	"menu.header.fontColor": "rgba(60, 60, 60, 0.5)",
	"menu.header.marginBottom": "12px",
	"menu.label.fontSize": "14px",
	"menu.label.default.fontWeight": 400,
	"menu.label.selected.fontWeight": 700,
	"menu.label.fontColor": "#3c3c3c",
	"menu.shortcut.fontSize": "12px",
	"menu.shortcut.fontWeight": 400,
	"menu.shortcut.fontColor": "rgba(60, 60, 60, 0.7)",
	"menu.item.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"menu.item.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"menu.item.focus.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"menu.item.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"menu.item.pressed.active.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"menu.item.paddingHorizontal": "12px",
	"menu.item.paddingVertical": "8px",
	"menu.item.minHeight": "18px",
	"menu.item.gutterWidth": "12px",
	"menu.item.checkmark.hover.iconColor": "rgba(102, 102, 102, 0.7)",
	"menu.item.checkmark.active.iconColor": "#0696d7",
	"menu.item.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"modal.fontColor": "#3c3c3c",
	"modal.paddingHorizontal": "24px",
	"modal.overlayColor": "rgba(0, 0, 0, 0.5)",
	"modal.header.backgroundColor": "#ffffff",
	"modal.header.borderBottomColor": "rgba(60, 60, 60, 0.25)",
	"modal.header.minHeight": "58px",
	"modal.body.minHeight": "152px",
	"modal.shell.backgroundColor": "#ffffff",
	"modal.shell.borderRadius": "4px",
	"modal.shell.minHeight": "300px",
	"modal.shell.minWidth": "400px",
	"modal.shell.shadowColor": "rgba(0, 0, 0, 0.2)",
	"modal.header.fontSize": "20px",
	"modal.header.fontWeight": 600,
	"modal.header.paddingBottom": "8px",
	"modal.subhead.fontSize": "14px",
	"modal.subhead.fontWeight": 400,
	"modal.fontFamily": "ArtifaktElement, sans-serif",
	"notifications.borderRadius": "4px",
	"notifications.fontColor": "#3c3c3c",
	"notifications.fontFamily": "ArtifaktElement, sans-serif",
	"notifications.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"notifications.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"notifications.container.backgroundColor": "#ffffff",
	"notifications.container.borderColor": "rgba(255, 255, 255, 0.01)",
	"notifications.container.shadowBlur": "4px",
	"notifications.container.shadowColor": "rgba(0, 0, 0, 0.2)",
	"notifications.statusIndicator.width": "3px",
	"notifications.header.fontSize": "14px",
	"notifications.header.fontWeight": 700,
	"notifications.header.lineHeight": "20px",
	"notifications.toast.object.fontSize": "12px",
	"notifications.toast.object.fontWeight": 700,
	"notifications.toast.object.lineHeight": "16px",
	"notifications.toast.description.fontSize": "12px",
	"notifications.toast.description.fontWeight": 400,
	"notifications.toast.description.lineHeight": "16px",
	"panel.container.backgroundColor": "#ffffff",
	"panel.container.padding": "12px",
	"panel.header.actions.padding": "8px",
	"panel.header.backgroundColor": "#d9d9d9",
	"panel.header.labelIcon.marginRight": "12px",
	"panel.header.minHeight": "40px",
	"panel.header.paddingHorizontal": "8px",
	"panel.header.paddingVertical": "4px",
	"panel.label.fontColor": "#3c3c3c",
	"panel.label.fontFamily": "ArtifaktElement, sans-serif",
	"panel.label.fontSize": "14px",
	"panel.label.fontWeight": 400,
	"panel.resize.backgroundColor": "#d9d9d9",
	"panel.resize.grip.backgroundColor": "#808080",
	"progress.bar.backgroundColor": "rgba(0, 0, 0, 0.05)",
	"progress.bar.highlightColor": "#38abdf",
	"progress.bar.borderRadius": "2px",
	"progress.bar.minHeight": "4px",
	"progress.ring.backgroundColor": "rgba(0, 0, 0, 0.05)",
	"progress.ring.highlightColor1": "#007fc6",
	"progress.ring.highlightColor2": "#38abdf",
	"scrollbar.radii": "1000em",
	"scrollbar.height": "5px",
	"scrollbar.default.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"scrollbar.pressed.backgroundColor": "rgba(128, 128, 128, 0.5)",
	"sideNav.fontFamily": "ArtifaktElement, sans-serif",
	"sideNav.container.backgroundColor": "#ffffff",
	"sideNav.account.fontColor": "#3c3c3c",
	"sideNav.account.fontSize": "12px",
	"sideNav.account.fontWeight": 500,
	"sideNav.account.lineHeight": "1.428571429",
	"sideNav.project.fontColor": "#3c3c3c",
	"sideNav.project.fontSize": "14px",
	"sideNav.project.fontWeight": 700,
	"sideNav.project.lineHeight": "1.428571429",
	"sideNav.module.default.fontColor": "#3c3c3c",
	"sideNav.module.default.fontSize": "14px",
	"sideNav.module.default.fontWeight": 700,
	"sideNav.module.default.lineHeight": "1.428571429",
	"sideNav.module.active.fontColor": "#0696d7",
	"sideNav.module.active.fontSize": "14px",
	"sideNav.module.active.fontWeight": 700,
	"sideNav.module.active.lineHeight": "1.428571429",
	"sideNav.subModule.default.fontColor": "#3c3c3c",
	"sideNav.subModule.default.fontSize": "14px",
	"sideNav.subModule.default.fontWeight": 400,
	"sideNav.subModule.default.lineHeight": "1.428571429",
	"sideNav.subModule.active.fontColor": "#0696d7",
	"sideNav.subModule.active.fontSize": "14px",
	"sideNav.subModule.active.fontWeight": 400,
	"sideNav.subModule.active.lineHeight": "1.428571429",
	"sideNav.legal.fontColor": "#3c3c3c",
	"sideNav.legal.fontSize": "12px",
	"sideNav.legal.fontWeight": 500,
	"sideNav.legal.lineHeight": "1.5",
	"sideNav.icon.defaultColor": "#3c3c3c",
	"sideNav.icon.activeColor": "#0696d7",
	"sideNav.activeIndicator.backgroundColor": "#0696d7",
	"skeletonItem.borderRadius": "2px",
	"skeletonItem.minHeight": "16px",
	"skeletonItem.backgroundColor": "rgba(0, 0, 0, 0.06)",
	"skeletonItem.highlightColor": "rgba(255, 255, 255, 0.3)",
	"slider.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"slider.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"slider.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"slider.hover.haloWidth": "2px",
	"slider.focus.haloWidth": "2px",
	"slider.pressed.haloWidth": "4px",
	"slider.thumb.backgroundColor": "#808080",
	"slider.thumb.minWidth": "6px",
	"slider.thumb.minHeight": "20px",
	"slider.track.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"slider.track.minHeight": "2px",
	"slider.value.backgroundColor": "#808080",
	"slider.inputOverlay.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"stepIndicator.fontFamily": "ArtifaktElement, sans-serif",
	"stepIndicator.borderWidth": "2px",
	"stepIndicator.minDiameter": "22px",
	"stepIndicator.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"stepIndicator.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"stepIndicator.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"stepIndicator.hover.haloWidth": "2px",
	"stepIndicator.focus.haloWidth": "2px",
	"stepIndicator.pressed.haloWidth": "4px",
	"stepIndicator.incomplete.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"stepIndicator.incomplete.borderColor": "#dcdcdc",
	"stepIndicator.inProgress.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"stepIndicator.inProgress.borderColor": "#0696d7",
	"stepIndicator.completed.backgroundColor": "#0696d7",
	"stepIndicator.completed.iconColor": "#ffffff",
	"stepIndicator.accordion.paddingHorizontal": "16px",
	"stepIndicator.accordion.paddingVertical": "24px",
	"stepIndicator.connector.minWidth": "2px",
	"stepIndicator.connector.default.backgroundColor": "#dcdcdc",
	"stepIndicator.connector.active.backgroundColor": "#0696d7",
	"stepIndicator.label.fontColor": "#3c3c3c",
	"stepIndicator.label.default.fontWeight": 400,
	"stepIndicator.label.horizontal.fontSize": "12px",
	"stepIndicator.label.horizontal.marginBottom": "12px",
	"stepIndicator.label.horizontal.marginTop": "12px",
	"stepIndicator.label.vertical.fontSize": "14px",
	"stepIndicator.label.vertical.marginLeft": "12px",
	"stepIndicator.label.inProgress.fontWeight": 700,
	"stepIndicator.number.fontSize": "14px",
	"stepIndicator.number.inProgress.fontColor": "#0696d7",
	"stepIndicator.number.inProgress.fontWeight": 700,
	"stepIndicator.number.incomplete.fontColor": "rgba(60, 60, 60, 0.4)",
	"stepIndicator.number.incomplete.fontWeight": 600,
	"table.borderWidth": "1px",
	"table.background.backgroundColor": "rgba(255, 255, 255, 0.8)",
	"table.borderRightColor": "rgba(60, 60, 60, 0.1)",
	"table.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"table.focus.haloWidth": "2px",
	"table.fontColor": "#3c3c3c",
	"table.fontFamily": "ArtifaktElement, sans-serif",
	"table.fontSize": "14px",
	"table.lineHeight": "1.428571429",
	"table.cell.fontWeight": 400,
	"table.cell.action.marginLeft": "12px",
	"table.cell.gutter": "12px",
	"table.cell.iconColor": "#808080",
	"table.cell.paddingHorizontal": "16px",
	"table.cell.paddingVertical": "4px",
	"table.cell.minHeight": "32px",
	"table.frozenColumn.shadowBlur": "4px",
	"table.frozenColumn.shadowColor": "rgba(0, 0, 0, 0.2)",
	"table.cell.multiSelect.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"table.cell.multiSelect.default.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.multiSelect.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"table.cell.multiSelect.focus.borderColor": "#0696d7",
	"table.cell.multiSelect.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"table.cell.multiSelect.hover.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.multiSelect.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
	"table.cell.multiSelect.pressed.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.null.backgroundColor": "#d9d9d9",
	"table.cell.selected.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"table.cell.selected.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.selected.focus.borderColor": "#0696d7",
	"table.cell.selected.hover.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.selected.hover.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.selected.pressed.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.selected.pressed.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.unselected.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.unselected.default.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.unselected.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.cell.unselected.focus.borderColor": "#0696d7",
	"table.cell.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"table.cell.unselected.hover.borderColor": "rgba(128, 128, 128, 0)",
	"table.cell.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"table.cell.unselected.pressed.borderColor": "rgba(128, 128, 128, 0)",
	"table.header.minHeight": "40px",
	"table.header.backgroundColor": "rgba(204, 204, 204, 0.4)",
	"table.header.iconColor": "#808080",
	"table.header.indicatorColor": "rgba(102, 102, 102, 0.7)",
	"table.header.selected.default.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"table.header.selected.default.borderColor": "rgba(128, 128, 128, 0)",
	"table.header.selected.focus.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"table.header.selected.focus.borderColor": "#0696d7",
	"table.header.unselected.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.header.unselected.default.borderColor": "rgba(128, 128, 128, 0)",
	"table.header.unselected.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.header.unselected.focus.borderColor": "#0696d7",
	"table.header.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"table.header.unselected.hover.borderColor": "rgba(128, 128, 128, 0)",
	"table.header.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"table.header.unselected.pressed.borderColor": "rgba(128, 128, 128, 0)",
	"table.header.default.fontWeight": 400,
	"table.header.selected.fontWeight": 700,
	"table.resize.hover.borderColor": "rgba(60, 60, 60, 0.25)",
	"table.resize.pressed.borderColor": "#0696d7",
	"table.row.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.row.checkbox.padding": "8px",
	"table.row.unselected.default.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.row.unselected.default.borderColor": "rgba(60, 60, 60, 0.1)",
	"table.row.unselected.focus.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"table.row.unselected.focus.borderColor": "#0696d7",
	"table.row.unselected.hover.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"table.row.unselected.hover.borderColor": "rgba(60, 60, 60, 0.1)",
	"table.row.unselected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"table.row.unselected.pressed.borderColor": "rgba(60, 60, 60, 0.1)",
	"table.row.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"table.row.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"table.row.selected.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"table.row.selected.focus.borderColor": "#0696d7",
	"table.row.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"table.row.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
	"table.row.selected.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
	"table.row.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
	"table.row.drag.backgroundColor": "#ffffff",
	"table.row.drag.fontWeight": 700,
	"table.row.drag.iconColor": "#808080",
	"table.row.drag.gutter": "16px",
	"table.row.drag.paddingLeft": "4px",
	"table.row.drag.paddingRight": "16px",
	"table.row.drag.paddingVertical": "4px",
	"table.row.drag.shadowBlur": "4px",
	"table.row.drag.shadowColor": "rgba(0, 0, 0, 0.2)",
	"table.zebraStripe.backgroundColor": "rgba(204, 204, 204, 0.2)",
	"tabs.focus.haloWidth": "2px",
	"tabs.focus.haloColor": "rgba(6, 150, 215, 0.5)",
	"tabs.label.fontColor": "#3c3c3c",
	"tabs.label.fontFamily": "ArtifaktElement, sans-serif",
	"tabs.label.fontSize": "14px",
	"tabs.label.inactive.fontWeight": 400,
	"tabs.label.active.fontWeight": 700,
	"tabs.label.active.lineHeight": "1.428571429",
	"tabs.iconSize": "24px",
	"tabs.iconColor": "#808080",
	"tabs.iconGutter": "12px",
	"tabs.closeButton.minSize": "16px",
	"tabs.closeButton.gutter": "12px",
	"tabs.closeButton.default.iconColor": "#808080",
	"tabs.closeButton.hover.iconColor": "#3c3c3c",
	"tabs.closeButton.pressed.iconColor": "#3c3c3c",
	"tabs.underline.wrapper.borderBottomColor": "rgba(128, 128, 128, 0.35)",
	"tabs.underline.wrapper.borderBottomWidth": "1px",
	"tabs.underline.tab.gutter": "24px",
	"tabs.underline.tab.paddingBottom": "8px",
	"tabs.underline.tab.paddingVertical": "8px",
	"tabs.underline.hover.haloColor": "rgba(128, 128, 128, 0.85)",
	"tabs.underline.active.haloColor": "#0696d7",
	"tabs.box.wrapper.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tabs.box.tab.paddingHorizontal": "12px",
	"tabs.box.tab.paddingVertical": "8px",
	"tabs.box.tab.active.backgroundColor": "#ffffff",
	"tabs.box.tab.hover.backgroundColor": "rgba(255, 255, 255, 0.5)",
	"tabs.box.divider.borderColor": "rgba(60, 60, 60, 0.25)",
	"tabs.box.dividerWidth": "1px",
	"tabs.box.dividerHeight": "18px",
	"tabs.canvas.wrapper.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tabs.canvas.tab.paddingHorizontal": "16px",
	"tabs.canvas.tab.paddingVertical": "8px",
	"tabs.canvas.tab.hover.backgroundColor": "rgba(245, 245, 245, 0.5)",
	"tabs.canvas.tab.active.backgroundColor": "#f5f5f5",
	"tabs.canvas.divider.borderColor": "rgba(60, 60, 60, 0.25)",
	"tabs.canvas.dividerWidth": "1px",
	"tabs.canvas.dividerHeight": "18px",
	"tag.borderWidth": "1px",
	"tag.borderRadii": "1000em",
	"tag.hover.haloWidth": "2px",
	"tag.focus.haloWidth": "4px",
	"tag.paddingLeft": "12px",
	"tag.paddingRight": "8px",
	"tag.paddingVertical": "8px",
	"tag.default.backgroundColor": "rgba(128, 128, 128, 0.15)",
	"tag.hover.backgroundColor": "rgba(128, 128, 128, 0.25)",
	"tag.focus.backgroundColor": "rgba(128, 128, 128, 0.15)",
	"tag.pressed.backgroundColor": "rgba(128, 128, 128, 0.35)",
	"tag.default.borderColor": "rgba(255, 255, 255, 0.01)",
	"tag.hover.borderColor": "rgba(255, 255, 255, 0.01)",
	"tag.focus.borderColor": "rgba(255, 255, 255, 0.01)",
	"tag.pressed.borderColor": "rgba(255, 255, 255, 0.01)",
	"tag.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"tag.on.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"tag.on.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"tag.on.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"tag.on.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
	"tag.on.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"tag.on.hover.borderColor": "rgba(6, 150, 215, 0.5)",
	"tag.on.focus.borderColor": "#0696d7",
	"tag.on.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
	"tag.on.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"tag.label.marginRight": "8px",
	"tag.label.fontColor": "#3c3c3c",
	"tag.label.fontFamily": "ArtifaktElement, sans-serif",
	"tag.label.fontSize": "14px",
	"tag.label.fontWeight": 600,
	"tag.closeButton.iconColor": "#808080",
	"textArea.minHeight": "250px",
	"textArea.borderColor": "rgba(128, 128, 128, 0.2)",
	"textLink.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"textLink.focus.haloWidth": "2px",
	"textLink.primary.default.fontColor": "#006eaf",
	"textLink.primary.hover.fontColor": "#006eaf",
	"textLink.primary.focus.fontColor": "#006eaf",
	"textLink.primary.hover.underlineColor": "#006eaf",
	"textLink.secondary.default.fontColor": "#3c3c3c",
	"textLink.secondary.hover.fontColor": "#3c3c3c",
	"textLink.secondary.focus.fontColor": "#3c3c3c",
	"textLink.secondary.hover.underlineColor": "#3c3c3c",
	"tile.borderRadii": "0",
	"tile.borderWidth": "1px",
	"tile.haloWidth": "4px",
	"tile.padding": "12px",
	"tile.fontColor": "#3c3c3c",
	"tile.fontFamily": "ArtifaktElement, sans-serif",
	"tile.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"tile.thumbnail.marginRight": "12px",
	"tile.title.fontSize": "14px",
	"tile.title.fontWeight": 700,
	"tile.title.lineHeight": "1.333333333",
	"tile.title.marginBottom": "8px",
	"tile.subTitle.fontSize": "12px",
	"tile.subTitle.fontWeight": 400,
	"tile.subTitle.lineHeight": "1.272727273",
	"tile.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"tile.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"tile.selected.focus.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"tile.selected.pressed.backgroundColor": "rgba(106, 192, 231, 0.7)",
	"tile.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"tile.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
	"tile.selected.focus.borderColor": "#0696d7",
	"tile.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
	"tile.filled.default.level100To250.backgroundColor": "rgba(128, 128, 128, 0.15)",
	"tile.filled.hover.level100To250.backgroundColor": "rgba(128, 128, 128, 0.25)",
	"tile.filled.focus.level100To250.backgroundColor": "rgba(128, 128, 128, 0.15)",
	"tile.filled.pressed.level100To250.backgroundColor": "rgba(128, 128, 128, 0.35)",
	"tile.filled.default.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.hover.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.focus.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.pressed.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.default.level300To350.backgroundColor": "rgba(255, 255, 255, 0.5)",
	"tile.filled.hover.level300To350.backgroundColor": "rgba(255, 255, 255, 0.7)",
	"tile.filled.focus.level300To350.backgroundColor": "rgba(255, 255, 255, 0.5)",
	"tile.filled.pressed.level300To350.backgroundColor": "#ffffff",
	"tile.filled.default.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.hover.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.focus.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.filled.pressed.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.default.level100To250.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.hover.level100To250.backgroundColor": "rgba(128, 128, 128, 0.1)",
	"tile.empty.focus.level100To250.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.pressed.level100To250.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"tile.empty.default.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.hover.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.focus.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.pressed.level100To250.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.default.level300To350.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.hover.level300To350.backgroundColor": "rgba(255, 255, 255, 0.25)",
	"tile.empty.focus.level300To350.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.pressed.level300To350.backgroundColor": "rgba(255, 255, 255, 0.35)",
	"tile.empty.default.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.hover.level300To350.borderColor": "rgba(255, 255, 255, 0.25)",
	"tile.empty.focus.level300To350.borderColor": "rgba(255, 255, 255, 0.01)",
	"tile.empty.pressed.level300To350.borderColor": "rgba(255, 255, 255, 0.35)",
	"tile.actions.backgroundColor": "rgba(217, 217, 217, 0.95)",
	"tile.actions.vertical.paddingVertical": "12px",
	"tile.actions.vertical.paddingHorizontal": "4px",
	"tile.actions.horizontal.paddingVertical": "4px",
	"tile.actions.horizontal.paddingHorizontal": "12px",
	"tile.divider.borderColor": "rgba(60, 60, 60, 0.1)",
	"tile.divider.borderWidth": "1px",
	"tile.checkboxContainer.padding": "12px",
	"tile.checkbox.unchecked.backgroundColor": "rgba(255, 255, 255, 0.01)",
	"tile.checkbox.checked.backgroundColor": "#ffffff",
	"tile.checkbox.indicatorColor": "#3c3c3c",
	"tile.checkbox.borderWidth": "#535353",
	"tile.checkbox.unchecked.default.borderColor": "rgba(255, 255, 255, 0.5)",
	"tile.checkbox.unchecked.hover.borderColor": "rgba(255, 255, 255, 0.5)",
	"tile.checkbox.unchecked.focus.borderColor": "#38abdf",
	"tile.checkbox.unchecked.pressed.borderColor": "rgba(255, 255, 255, 0.5)",
	"tile.checkbox.checked.default.borderColor": "#ffffff",
	"tile.checkbox.checked.hover.borderColor": "#ffffff",
	"tile.checkbox.checked.focus.borderColor": "#ffffff",
	"tile.checkbox.checked.pressed.borderColor": "#ffffff",
	"tile.checkbox.hover.haloWidth": "2px",
	"tile.checkbox.focus.haloWidth": "2px",
	"tile.checkbox.pressed.haloWidth": "4px",
	"tile.checkbox.hover.haloColor": "rgba(255, 255, 255, 0.15)",
	"tile.checkbox.focus.haloColor": "rgba(56, 171, 223, 0.35)",
	"tile.checkbox.pressed.haloColor": "rgba(255, 255, 255, 0.25)",
	"tile.title.paddingTop": "8px",
	"tile.subtitle.paddingBottom": "12px",
	"tile.children.spaceBetween": "12px",
	"tile.children.paddingBottom": "12px",
	"tile.gradient.height": "60px",
	"tile.gradient.start.backgroundColor": "#000000",
	"tile.gradient.end.backgroundColor": "rgba(204, 204, 204, 0)",
	"tile.gradient.opacity": "0.85",
	"timestamp.fontColor": "rgba(60, 60, 60, 0.7)",
	"timestamp.fontFamily": "ArtifaktElement, sans-serif",
	"timestamp.fontSize": "12px",
	"timestamp.fontWeight": 400,
	"timestamp.lineHeight": "20px",
	"thumbnail.backgroundColor": "#eeeeee",
	"thumbnail.borderColor": "rgba(128, 128, 128, 0.5)",
	"thumbnail.extraExtraSmall.height": "24px",
	"thumbnail.extraSmall.height": "32px",
	"thumbnail.small.height": "48px",
	"thumbnail.medium.height": "64px",
	"thumbnail.large.height": "96px",
	"thumbnail.extraLarge.height": "128px",
	"thumbnail.borderRadius": "2px",
	"toggle.borderRadii": "1000em",
	"toggle.borderWidth": "1px",
	"toggle.minHeight": "20px",
	"toggle.minWidth": "37px",
	"toggle.padding": "4px",
	"toggle.hover.haloColor": "rgba(128, 128, 128, 0.15)",
	"toggle.focus.haloColor": "rgba(6, 150, 215, 0.35)",
	"toggle.pressed.haloColor": "rgba(128, 128, 128, 0.25)",
	"toggle.hover.haloWidth": "2px",
	"toggle.focus.haloWidth": "2px",
	"toggle.pressed.haloWidth": "4px",
	"toggle.off.default.backgroundColor": "#ffffff",
	"toggle.off.default.borderColor": "rgba(128, 128, 128, 0.5)",
	"toggle.off.hover.backgroundColor": "#ffffff",
	"toggle.off.focus.backgroundColor": "#ffffff",
	"toggle.off.pressed.backgroundColor": "#ffffff",
	"toggle.off.hover.borderColor": "rgba(128, 128, 128, 0.5)",
	"toggle.off.focus.borderColor": "#0696d7",
	"toggle.off.pressed.borderColor": "rgba(128, 128, 128, 0.5)",
	"toggle.on.default.backgroundColor": "#0696d7",
	"toggle.on.default.borderColor": "#0696d7",
	"toggle.thumb.borderRadii": "50%",
	"toggle.thumb.minDiameter": "12px",
	"toggle.thumb.on.backgroundColor": "#ffffff",
	"toggle.thumb.off.backgroundColor": "#808080",
	"token.borderRadii": "0",
	"token.paddingLeft": "8px",
	"token.paddingRight": "4px",
	"token.paddingVertical": "4px",
	"token.default.backgroundColor": "rgba(128, 128, 128, 0.15)",
	"token.hover.backgroundColor": "rgba(128, 128, 128, 0.25)",
	"token.pressed.backgroundColor": "rgba(128, 128, 128, 0.35)",
	"token.default.borderColor": "rgba(255, 255, 255, 0.01)",
	"token.hover.borderColor": "rgba(255, 255, 255, 0.01)",
	"token.pressed.borderColor": "rgba(255, 255, 255, 0.01)",
	"token.selected.default.backgroundColor": "rgba(205, 234, 247, 0.6)",
	"token.selected.hover.backgroundColor": "rgba(155, 213, 239, 0.7)",
	"token.selected.pressed.backgroundColor": "rgba(128, 128, 128, 0.2)",
	"token.selected.default.borderColor": "rgba(6, 150, 215, 0.5)",
	"token.selected.hover.borderColor": "rgba(6, 150, 215, 0.5)",
	"token.selected.pressed.borderColor": "rgba(6, 150, 215, 0.5)",
	"token.warning.default.backgroundColor": "rgba(250, 162, 27, 0.15)",
	"token.warning.hover.backgroundColor": "rgba(250, 162, 27, 0.3)",
	"token.warning.iconColor": "#faa21b",
	"token.icon.marginRight": "8px",
	"token.label.fontColor": "#3c3c3c",
	"token.label.fontFamily": "ArtifaktElement, sans-serif",
	"token.label.fontSize": "14px",
	"token.label.fontWeight": 600,
	"token.label.marginRight": "4px",
	"token.closeButton.iconColor": "#808080",
	"tooltip.backgroundColor": "#535353",
	"tooltip.borderRadius": "2px",
	"tooltip.shadowBlur": "16px",
	"tooltip.shadowColor": "rgba(0, 0, 0, 0.2)",
	"tooltip.title.fontColor": "#f5f5f5",
	"tooltip.title.fontFamily": "ArtifaktElement, sans-serif",
	"tooltip.title.fontSize": "12px",
	"tooltip.title.fontWeight": 700,
	"tooltip.title.lineHeight": 1.333333333,
	"tooltip.nub.hypotenuseLength": "16px",
	"tooltip.description.fontColor": "#f5f5f5",
	"tooltip.description.fontFamily": "ArtifaktElement, sans-serif",
	"tooltip.description.fontSize": "12px",
	"tooltip.description.fontWeight": 400,
	"tooltip.description.lineHeight": 1.333333333,
	"tooltip.divider.borderBottomColor": "rgba(255, 255, 255, 0.1)",
	"tooltip.link.fontColor": "#6dd2ff",
	"tooltip.link.paddingTop": "12px",
	"tooltip.paddingHorizontal": "12px",
	"tooltip.small.paddingVertical": "8px",
	"tooltip.medium.paddingVertical": "12px",
	"tooltip.medium.spaceBetween": "8px",
	"tooltip.large.paddingVertical": "12px",
	"tooltip.large.spaceBetween": "12px",
	"tooltip.maxWidth": "240px",
	"tooltip.nub.width": "8px",
	"tooltip.nub.height": "4px",
	"tooltip.nub.padding": "8px",
	"tooltip.nub.spaceBetween": "4px",
	"tooltip.shortcut.paddingHorizontal": "4px",
	"tooltip.shortcut.height": "16px",
	"tooltip.shortcut.borderRadius": "2px",
	"tooltip.shortcut.backgroundColor": "#666666",
	"tooltip.shortcut.fontColor": "#f5f5f5",
	"tooltip.shortcut.fontFamily": "ArtifaktElement, sans-serif",
	"tooltip.shortcut.fontSize": "12px",
	"tooltip.shortcut.fontWeight": 400,
	"tooltip.shortcut.lineHeight": 1.333333333,
	"tooltip.button.paddingHorizontal": "12px",
	"tooltip.button.paddingVertical": "4px",
	"tooltip.button.label.fontSize": "12px",
	"tooltip.button.label.fontWeight": 600,
	"tooltip.button.label.lineHeight": "1.272727273",
	"tooltip.button.label.fontColor": "#f5f5f5",
	"tooltip.button.hover.haloColor": "rgba(255, 255, 255, 0.15)",
	"tooltip.button.focus.haloColor": "rgba(56, 171, 223, 0.35)",
	"tooltip.button.pressed.haloColor": "rgba(255, 255, 255, 0.25)",
	"tooltip.button.default.borderColor": "rgba(255, 255, 255, 0.5)",
	"tooltip.button.hover.borderColor": "rgba(255, 255, 255, 0.5)",
	"tooltip.button.focus.borderColor": "#38abdf",
	"tooltip.button.pressed.borderColor": "rgba(255, 255, 255, 0.75)",
	"topNav.padding": "12px",
	"topNav.backgroundColor": "#ffffff",
	"topNav.borderColor": "rgba(60, 60, 60, 0.1)",
	"topNav.productLockupColor": "#000000",
	"topNav.hamburgetIcon.margin": "8px",
	"treeView.fontColor": "#3c3c3c",
	"treeView.fontFamily": "ArtifaktElement, sans-serif",
	"treeView.indicatorColor": "#3c3c3c",
	"treeView.icon.marginRight": "8px",
	"treeView.row.height": "40px",
	"treeView.row.paddingHorizontal": "12px",
	"treeView.row.paddingVertical": "8px",
	"treeView.title.fontSize": "14px",
	"treeView.title.fontWeight": 600,
	"treeView.title.lineHeight": "1.428571429",
	"treeView.item.fontSize": "14px",
	"treeView.item.fontWeight": 600,
	"treeView.item.lineHeight": "1.428571429",
	"treeView.guideLine.backgroundColor": "rgba(128, 128, 128, 0.5)",
	"typography.body.fontFamily": "ArtifaktElement, sans-serif",
	"typography.body.fontWeight": 400,
	"typography.body.fontSize": "14px",
	"typography.body.lineHeight": "1.428571429",
	"typography.body.color": "#3c3c3c",
	"typography.caption.fontFamily": "ArtifaktElement, sans-serif",
	"typography.caption.fontWeight": 400,
	"typography.caption.fontSize": "12px",
	"typography.caption.lineHeight": "1.5",
	"typography.caption.color": "#3c3c3c",
	"typography.h1.fontFamily": "ArtifaktElement, sans-serif",
	"typography.h1.fontWeight": 400,
	"typography.h1.fontSize": "28px",
	"typography.h1.lineHeight": "1.285714286",
	"typography.h1.color": "#3c3c3c",
	"typography.h2.fontFamily": "ArtifaktElement, sans-serif",
	"typography.h2.fontWeight": 400,
	"typography.h2.fontSize": "24px",
	"typography.h2.lineHeight": "1.25",
	"typography.h2.color": "#3c3c3c",
	"typography.h3.fontFamily": "ArtifaktElement, sans-serif",
	"typography.h3.fontWeight": 600,
	"typography.h3.fontSize": "20px",
	"typography.h3.lineHeight": "1.3",
	"typography.h3.color": "#3c3c3c"
};
var defaultTheme = {
	metadata: metadata,
	resolvedRoles: resolvedRoles
};

const {
  Provider,
  Consumer: Consumer$1
} = /*#__PURE__*/createContext(defaultTheme);

function isPresent(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function hasRoleFormat(prop) {
  return prop.search(/\./) > 0;
}

function resolvedRolesProxy(roles, theme) {
  if (typeof roles !== "object") return roles;
  return new Proxy(roles, {
    get: (obj, prop) => {
      if (hasRoleFormat(prop) && !isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error(`Role ${prop.toString()} does not exist`);
        return obj[prop];
      }

      const hasRoleDeprecationInfo = isPresent(theme, "metadata") && isPresent(theme.metadata, "__deprecated__") && isPresent(theme.metadata.__deprecated__, prop);

      if (hasRoleDeprecationInfo) {
        const roleDeprecationInfo = theme.metadata.__deprecated__[prop];
        const equivalencyInfo = roleDeprecationInfo.equivalent ? ` and has been renamed to ${roleDeprecationInfo.equivalent.toString()}.` : ".";
        /* eslint-disable-next-line no-console */

        console.warn(`Role ${prop.toString()} is deprecated${equivalencyInfo}`);
      }

      return obj[prop];
    }
  });
}

function createThemeProxy(theme) {
  return new Proxy(theme, {
    get: (obj, prop) => {
      const value = obj[prop];
      if (prop.toString() === "resolvedRoles") return resolvedRolesProxy(value, theme);

      if (!isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error(`Property ${prop.toString()} does not exist.`);
        return value;
      }

      if (typeof value === "object" && value !== null) return createThemeProxy(value);
      return value;
    }
  });
}

const Consumer = props => /*#__PURE__*/React.createElement(Consumer$1, null, theme => {
  const isDebugging = process.env.NODE_ENV !== "production";
  const result = isDebugging ? createThemeProxy(theme) : theme;
  return props.children(result);
});

Consumer.displayName = "Consumer";
Consumer.propTypes = {
  /** A theme provided to the consumer within */
  children: PropTypes.func
};
Consumer.__docgenInfo = {
  "description": "",
  "displayName": "Consumer",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A theme provided to the consumer within"
    }
  }
};
var index = {
  Provider,
  Consumer
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const anchorPoints = Object.freeze({
  TOP_LEFT: "top-left",
  TOP_CENTER: "top-center",
  TOP_RIGHT: "top-right",
  RIGHT_TOP: "right-top",
  RIGHT_CENTER: "right-center",
  RIGHT_BOTTOM: "right-bottom",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_CENTER: "bottom-center",
  BOTTOM_RIGHT: "bottom-right",
  LEFT_TOP: "left-top",
  LEFT_CENTER: "left-center",
  LEFT_BOTTOM: "left-bottom"
});
const AVAILABLE_ANCHOR_POINTS = Object.freeze(Object.values(anchorPoints));
const HIDDEN = "hidden";
const transitionStatuses = Object.freeze({
  ENTERED,
  ENTERING,
  EXITED,
  EXITING,
  HIDDEN
});
const AVAILABLE_TRANSITION_STATUSES = Object.freeze(Object.values(transitionStatuses));
const TRANSITION_DURATION = 300;

class ContainerTransition extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      in: this.props.open,
      isVisible: this.props.open
    });

    _defineProperty(this, "handleExit", () => {
      this.hide();
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.show();
    } else if (prevProps.open && !this.props.open) {
      this.beginExit();
    }
  }
  /**
   * @param {string} transitionState
   * @returns {string}
   */


  getTransitionStatus(transitionState) {
    return !this.state.isVisible ? transitionStatuses.HIDDEN : transitionState;
  } // eslint-disable-next-line react/sort-comp


  beginExit() {
    window.requestAnimationFrame(() => {
      this.setState({
        in: false
      });
    });
  }

  show() {
    window.requestAnimationFrame(() => {
      this.setState({
        isVisible: true
      }, () => {
        window.requestAnimationFrame(() => {
          this.setState({
            in: true
          });
        });
      });
    });
  }

  hide() {
    window.requestAnimationFrame(() => {
      this.setState({
        isVisible: false
      });
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(Transition, {
      in: this.state.in,
      onExited: this.handleExit,
      timeout: TRANSITION_DURATION
    }, transitionState => this.props.children(this.getTransitionStatus(transitionState)));
  }

}

_defineProperty(ContainerTransition, "propTypes", {
  children: PropTypes.func.isRequired,
  open: PropTypes.bool
});

_defineProperty(ContainerTransition, "defaultProps", {
  open: false
});

ContainerTransition.__docgenInfo = {
  "description": "",
  "displayName": "ContainerTransition",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    }
  }
};
/**
 * @typedef {Object} Payload
 * @property {string} anchorPoint
 * @property {DOMRect} actionRect
 * @property {DOMRect} panelRect
 * @property {DOMRect} pointerRect
 * @property {DOMRect} viewportRect
 */

/**
 * @typedef {Object} Position
 * @property {number} top
 * @property {number} left
 */

/**
 * @typedef {Object} Coordinates
 * @property {string} anchorPoint
 * @property {Position} containerPosition
 * @property {Position} pointerPosition
 */

const ACTION_OVERLAP = 0;
const POINTER_OVERLAP = 1;
const {
  TOP_LEFT,
  TOP_CENTER,
  TOP_RIGHT,
  RIGHT_TOP,
  RIGHT_CENTER,
  RIGHT_BOTTOM,
  BOTTOM_LEFT,
  BOTTOM_CENTER,
  BOTTOM_RIGHT,
  LEFT_TOP,
  LEFT_CENTER,
  LEFT_BOTTOM
} = anchorPoints;
/**
 * @type {Position}
 */

const DEFAULT_POSITION = Object.freeze({
  top: 0,
  left: 0
});
/**
 * @type {Coordinates}
 */

const DEFAULT_COORDINATES = Object.freeze({
  anchorPoint: anchorPoints.TOP_LEFT,
  containerPosition: DEFAULT_POSITION,
  pointerPosition: DEFAULT_POSITION
});
/**
 * @param {Payload} payload
 * @returns {number}
 */

function calculatePointerTopOffset(_ref) {
  let {
    anchorPoint,
    actionRect,
    panelRect,
    pointerRect
  } = _ref;

  switch (anchorPoint) {
    case TOP_CENTER:
    case TOP_LEFT:
    case TOP_RIGHT:
      return -1 * (pointerRect.height - (pointerRect.height / 2 + POINTER_OVERLAP));

    case BOTTOM_CENTER:
    case BOTTOM_LEFT:
    case BOTTOM_RIGHT:
      return panelRect.height - (pointerRect.height / 2 + POINTER_OVERLAP);

    case LEFT_BOTTOM:
    case RIGHT_BOTTOM:
      return panelRect.height - actionRect.height / 2 - pointerRect.height / 2;

    case LEFT_CENTER:
    case RIGHT_CENTER:
      return panelRect.height / 2 - pointerRect.height / 2;

    case LEFT_TOP:
    case RIGHT_TOP:
      return actionRect.height / 2 - pointerRect.height / 2;

    default:
      return DEFAULT_COORDINATES.pointerPosition.top;
  }
}
/**
 * @param {Payload} payload
 * @returns {number}
 */


function calculatePointerLeftOffset(_ref2) {
  let {
    anchorPoint,
    actionRect,
    panelRect,
    pointerRect
  } = _ref2;

  switch (anchorPoint) {
    case LEFT_BOTTOM:
    case LEFT_CENTER:
    case LEFT_TOP:
      return -1 * (pointerRect.width - (pointerRect.width / 2 + POINTER_OVERLAP));

    case RIGHT_BOTTOM:
    case RIGHT_CENTER:
    case RIGHT_TOP:
      return panelRect.width - (pointerRect.width / 2 + POINTER_OVERLAP);

    case TOP_CENTER:
    case BOTTOM_CENTER:
      return panelRect.width / 2 - pointerRect.width / 2;

    case TOP_LEFT:
    case BOTTOM_LEFT:
      return actionRect.width / 2 - pointerRect.width / 2;

    case TOP_RIGHT:
    case BOTTOM_RIGHT:
      return panelRect.width - (actionRect.width / 2 + pointerRect.width / 2);

    default:
      return DEFAULT_COORDINATES.pointerPosition.left;
  }
}
/**
 * @param {Payload} payload
 * @returns {number}
 */


function calculatePanelContainerTopOffset(_ref3) {
  let {
    anchorPoint,
    actionRect,
    panelRect,
    pointerRect
  } = _ref3;

  switch (anchorPoint) {
    case TOP_LEFT:
    case TOP_CENTER:
    case TOP_RIGHT:
      return actionRect.height + pointerRect.height / 2 - ACTION_OVERLAP;

    case BOTTOM_LEFT:
    case BOTTOM_CENTER:
    case BOTTOM_RIGHT:
      return -1 * panelRect.height - pointerRect.height / 2 + ACTION_OVERLAP;

    case LEFT_TOP:
    case RIGHT_TOP:
      return 0;

    case LEFT_CENTER:
    case RIGHT_CENTER:
      return (panelRect.height - actionRect.height) / -2;

    case LEFT_BOTTOM:
    case RIGHT_BOTTOM:
      return -1 * (panelRect.height - actionRect.height);

    default:
      return DEFAULT_COORDINATES.containerPosition.top;
  }
}
/**
 * @param {Payload} payload
 * @returns {number}
 */


function calculatePanelContainerLeftOffset(_ref4) {
  let {
    anchorPoint,
    actionRect,
    panelRect,
    pointerRect
  } = _ref4;

  switch (anchorPoint) {
    case LEFT_TOP:
    case LEFT_CENTER:
    case LEFT_BOTTOM:
      return actionRect.width + pointerRect.width / 2 - ACTION_OVERLAP;

    case RIGHT_TOP:
    case RIGHT_CENTER:
    case RIGHT_BOTTOM:
      return -1 * panelRect.width - pointerRect.width / 2 + ACTION_OVERLAP;

    case TOP_LEFT:
    case BOTTOM_LEFT:
      return 0;

    case TOP_CENTER:
    case BOTTOM_CENTER:
      return -1 * ((panelRect.width - actionRect.width) / 2);

    case TOP_RIGHT:
    case BOTTOM_RIGHT:
      return -1 * (panelRect.width - actionRect.width);

    default:
      return DEFAULT_COORDINATES.containerPosition.top;
  }
}
/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */


function calculatePointerPosition(props) {
  return {
    top: calculatePointerTopOffset(props),
    left: calculatePointerLeftOffset(props)
  };
}
/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */


function calculatePanelContainerPosition(props) {
  return {
    top: calculatePanelContainerTopOffset(props),
    left: calculatePanelContainerLeftOffset(props)
  };
}
/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */


function calculateCoordinates(props) {
  return {
    anchorPoint: props.anchorPoint,
    containerPosition: calculatePanelContainerPosition(props),
    pointerPosition: calculatePointerPosition(props)
  };
}
/**
 * Determines whether the given position is entirely within the viewport
 * @param {Payload} payload
 * @returns {function(Coordinates): boolean}
 */


function createViewportDeterminer(props) {
  const {
    viewportRect,
    panelRect,
    actionRect
  } = props;
  return function isInViewport(_ref5) {
    let {
      containerPosition
    } = _ref5;
    const containerTop = actionRect.top + containerPosition.top;
    const containerLeft = actionRect.left + containerPosition.left;
    const containerRight = containerLeft + panelRect.width;
    const containerBottom = containerTop + panelRect.height;
    const result = containerLeft >= viewportRect.left && containerTop >= viewportRect.top && containerRight <= viewportRect.right && containerBottom <= viewportRect.bottom;
    return result;
  };
}
/**
 * @param {payload} GetFlyoutPositionPayload
 * @returns {FlyoutPosition}
 */


function getFallbackCoordinates(payload) {
  const isInViewport = createViewportDeterminer(payload);
  return payload.fallbackAnchorPoints.map(anchorPoint => calculateCoordinates(_objectSpread2(_objectSpread2({}, payload), {}, {
    anchorPoint
  }))).find(isInViewport);
}
/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */


function getCoordinates(payload) {
  const coordinates = calculateCoordinates(payload);
  const isInViewport = createViewportDeterminer(payload);

  if (isInViewport(coordinates)) {
    return coordinates;
  }

  const fallbackCoordinates = getFallbackCoordinates(payload);
  return fallbackCoordinates || coordinates;
}

function getStyle(themeData, role) {
  return themeData[role];
}

function getAnchorPointTransformTranslate(anchorPoint) {
  switch (anchorPoint) {
    case `top-left`:
    case `top-center`:
    case `top-right`:
      return `translateY(-4px)`;

    case `right-top`:
    case `right-center`:
    case `right-bottom`:
      return `translateX(4px)`;

    case `bottom-left`:
    case `bottom-center`:
    case `bottom-right`:
      return `translateY(4px)`;

    case `left-top`:
    case `left-center`:
    case `left-bottom`:
      return `translateX(-4px)`;

    default:
      return `none`;
  }
}

function getAnchorPointTransformRotate(anchorPoint) {
  switch (anchorPoint) {
    case `right-top`:
    case `right-center`:
    case `right-bottom`:
      return `rotate(90deg)`;

    case `bottom-left`:
    case `bottom-center`:
    case `bottom-right`:
      return `rotate(180deg)`;

    case `left-top`:
    case `left-center`:
    case `left-bottom`:
      return `rotate(-90deg)`;

    default:
      return `rotate(0deg)`;
  }
} // eslint-disable-next-line func-names


function stylesheet(props, themeData) {
  const {
    transitionStatus,
    anchorPoint,
    stylesheet
  } = props;
  const isExiting = transitionStatus === `exiting`;
  const isExited = transitionStatus === `exited`;
  const isHidden = transitionStatus === `hidden`;
  const backgroundColor = themeData ? getStyle(themeData, `flyout.backgroundColor`) : `transparent`;
  const borderColor = themeData ? getStyle(themeData, `flyout.borderColor`) : `none`;
  const borderRadius = themeData ? getStyle(themeData, `flyout.borderRadius`) : `none`;
  const shadowBlur = themeData ? getStyle(themeData, `flyout.shadowBlur`) : 0;
  const shadowColor = themeData ? getStyle(themeData, `flyout.shadowColor`) : `transparent`;
  const densitySmall = themeData ? getStyle(themeData, `density.spacings.small`) : 0;
  const styles = {
    flyoutWrapper: {
      position: `relative`,
      display: `inline-block`
    },
    flyoutAction: {
      display: `flex`
    },
    flyoutContainer: {
      position: `absolute`,
      // Resolves issues with negative positions and container overflow
      display: isHidden ? `none` : `table`,
      zIndex: 9999,
      transitionProperty: `opacity, transform`,
      transitionDuration: `250ms`,
      // Bounce effect
      transitionTimingFunction: `cubic-bezier(0.77, 0, 0.265, 2)`,
      touchAction: isExiting || isExited ? `none` : `auto`,
      pointerEvents: isExiting || isExited ? `none` : `auto`,
      opacity: isExiting || isExited ? 0 : 1,
      transform: isExiting || isExited ? getAnchorPointTransformTranslate(anchorPoint) : `none`
    },
    panelContainer: {
      backgroundColor,
      borderRadius,
      border: `none`,
      boxShadow: `0 0 ${shadowBlur} ${shadowColor}`
    },
    panelContainerInner: {
      position: `relative`
    },
    panel: {
      minWidth: `200px`,
      maxHeight: `360px`,
      padding: densitySmall,
      overflowY: `auto`,
      msOverflowStyle: `-ms-autohiding-scrollbar`
    },
    pointerWrapper: {
      display: `flex`,
      position: `absolute`,
      transform: getAnchorPointTransformRotate(anchorPoint)
    },
    pointerBorder: {
      fill: borderColor
    },
    pointerBody: {
      fill: backgroundColor
    }
  };

  if (stylesheet) {
    return stylesheet(styles, props, themeData);
  }

  return styles;
}

function PointerPresenter(props) {
  const {
    borderWidth,
    size
  } = props;
  const height = size / 2;
  const width = size;
  const widthMidpoint = width / 2;
  return /*#__PURE__*/React.createElement(index.Consumer, null, _ref => {
    let {
      resolvedRoles
    } = _ref;
    const styles = stylesheet(props, resolvedRoles);
    return /*#__PURE__*/React.createElement("svg", {
      height: size.toString(),
      viewBox: `0 0 ${size} ${size}`,
      width: width.toString()
    }, /*#__PURE__*/React.createElement("polygon", {
      className: css(styles.pointerBorder),
      points: [`0,${height}`, `${widthMidpoint},0`, `${width},${height}`].join(" ")
    }), /*#__PURE__*/React.createElement("polygon", {
      className: css(styles.pointerBody),
      points: [`${borderWidth},${height}`, `${widthMidpoint},${borderWidth}`, `${width - borderWidth},${height}`].join(" ")
    }));
  });
}

PointerPresenter.defaultProps = {
  borderWidth: 2.5,
  size: 24
};
PointerPresenter.propTypes = {
  borderWidth: PropTypes.number,
  size: PropTypes.number
};
PointerPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PointerPresenter",
  "props": {
    "borderWidth": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "2.5",
        "computed": false
      }
    },
    "size": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "24",
        "computed": false
      }
    }
  }
};
const _excluded$4 = ["children", "innerRef", "style", "anchorPoint", "stylesheet"];

function PointerWrapperPresenter(_ref) {
  let {
    children,
    innerRef,
    style,
    anchorPoint,
    stylesheet: customStylesheet
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4);

  const styles = stylesheet({
    transitionStatus: null,
    anchorPoint,
    stylesheet: customStylesheet
  });
  const {
    className
  } = otherProps;
  const pointerWrapperClassName = createCustomClassNames(className, "pointer-wrapper");
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: cx(css(styles.pointerWrapper), pointerWrapperClassName),
    ref: innerRef,
    role: "presentation",
    style: style
  }, children);
}

PointerWrapperPresenter.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.func,

  /* eslint-disable-next-line react/forbid-prop-types */
  style: PropTypes.object,
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  stylesheet: PropTypes.func
};
PointerWrapperPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PointerWrapperPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "style": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
const _excluded$3 = ["anchorPoint", "containerPosition", "children", "panel", "pointer", "pointerPosition", "refAction", "refPointer", "refWrapper", "transitionStatus", "stylesheet"];
/**
 * @param {import("../getCoordinates").Position} position
 * @returns {import("react").CSSProperties}
 */

function positionToStyle(_ref) {
  let {
    top,
    left
  } = _ref;
  return {
    top: `${top}px`,
    left: `${left}px`
  };
}

function FlyoutPresenter(props) {
  const {
    anchorPoint,
    containerPosition,
    children,
    panel,
    pointer,
    pointerPosition,
    refAction,
    refPointer,
    refWrapper,
    transitionStatus,
    stylesheet: customStylesheet
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$3);

  const {
    className
  } = otherProps;
  const flyoutActionClassName = createCustomClassNames(className, "flyout-action");
  const flyoutContainerClassName = createCustomClassNames(className, "flyout-container");
  const containerStyle = positionToStyle(containerPosition);
  const pointerStyle = positionToStyle(pointerPosition);
  return /*#__PURE__*/React.createElement(index.Consumer, null, _ref2 => {
    let {
      resolvedRoles
    } = _ref2;
    const styles = stylesheet({
      transitionStatus,
      anchorPoint,
      stylesheet: customStylesheet
    }, resolvedRoles);
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.flyoutWrapper), className),
      ref: refWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.flyoutAction), flyoutActionClassName),
      ref: refAction
    }, children), /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.flyoutContainer), flyoutContainerClassName),
      style: containerStyle
    }, /*#__PURE__*/React.createElement(PointerWrapperPresenter, {
      innerRef: refPointer,
      anchorPoint: anchorPoint,
      style: pointerStyle,
      className: className,
      stylesheet: customStylesheet
    }, pointer || /*#__PURE__*/React.createElement(PointerPresenter, {
      stylesheet: customStylesheet
    })), panel));
  });
}

FlyoutPresenter.defaultProps = {
  anchorPoint: DEFAULT_COORDINATES.anchorPoint,
  containerPosition: DEFAULT_COORDINATES.containerPosition,
  pointerPosition: DEFAULT_COORDINATES.pointerPosition,
  transitionStatus: transitionStatuses.EXITED
};
FlyoutPresenter.propTypes = {
  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),

  /** Content for the flyout */
  panel: PropTypes.node,

  /** Pointer for the flyout */
  pointer: PropTypes.node,

  /** Top/Left position of the container relative to the action */
  containerPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),

  /** Top/Left position of the pointer relative to the action */
  pointerPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),

  /** Reference the action element */
  refAction: PropTypes.func,

  /** Reference the pointer element */
  refPointer: PropTypes.func,

  /** Reference the wrapper element */
  refWrapper: PropTypes.func,

  /** The status of the container transition */
  transitionStatus: PropTypes.oneOf(AVAILABLE_TRANSITION_STATUSES),

  /** Target component to open the flyout */
  children: PropTypes.node,

  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
FlyoutPresenter.__docgenInfo = {
  "description": "",
  "displayName": "FlyoutPresenter",
  "props": {
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.anchorPoint",
        "computed": true
      }
    },
    "panel": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Content for the flyout"
    },
    "pointer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Pointer for the flyout"
    },
    "containerPosition": {
      "type": {
        "name": "shape",
        "value": {
          "top": {
            "name": "number",
            "required": false
          },
          "left": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Top/Left position of the container relative to the action",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.containerPosition",
        "computed": true
      }
    },
    "pointerPosition": {
      "type": {
        "name": "shape",
        "value": {
          "top": {
            "name": "number",
            "required": false
          },
          "left": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Top/Left position of the pointer relative to the action",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.pointerPosition",
        "computed": true
      }
    },
    "refAction": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the action element"
    },
    "refPointer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the pointer element"
    },
    "refWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the wrapper element"
    },
    "transitionStatus": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_TRANSITION_STATUSES"
      },
      "required": false,
      "description": "The status of the container transition",
      "defaultValue": {
        "value": "transitionStatuses.EXITED",
        "computed": true
      }
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Target component to open the flyout"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

class HoverBehavior extends Component {
  // eslint-disable-next-line react/static-property-placement
  constructor(props) {
    super(props); // Binding in the constructor because performance

    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = {
      hasHover: false
    };
  }

  handleFocus(event) {
    const {
      openOnHoverDelay,
      onMouseEnter
    } = this.props;

    if (onMouseEnter) {
      this.focusTimeout = setTimeout(() => {
        this.setState({
          hasHover: true
        });
        onMouseEnter(event);
      }, openOnHoverDelay);
    }

    this.setState({
      hasHover: true
    });
  }

  handleBlur(event) {
    clearTimeout(this.focusTimeout);
    this.setState({
      hasHover: false
    });

    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(event);
    }
  }

  render() {
    return this.props.children({
      hasHover: this.state.hasHover,
      onMouseEnter: this.handleFocus,
      onMouseLeave: this.handleBlur
    });
  }

}

_defineProperty(HoverBehavior, "propTypes", {
  /**
   * Generally the Flyout target and presenter
   */
  children: PropTypes.func.isRequired,

  /**
   * Amount of time between mouse enter is reported and when
   * onMouseEnter event should fire
   */
  openOnHoverDelay: PropTypes.number,

  /**
   * Function called when the user enters the visual space
   * occupied by the component
   */
  onMouseEnter: PropTypes.func,

  /**
   * Function called when the user leaves the visual space
   * occupied by the component
   */
  onMouseLeave: PropTypes.func
});

HoverBehavior.__docgenInfo = {
  "description": "",
  "displayName": "HoverBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Generally the Flyout target and presenter"
    },
    "openOnHoverDelay": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Amount of time between mouse enter is reported and when\nonMouseEnter event should fire"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the user enters the visual space\noccupied by the component"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the user leaves the visual space\noccupied by the component"
    }
  }
};
const _excluded$2 = ["children", "innerRef", "maxHeight", "stylesheet"];

function PanelContainerPresenter(props) {
  const {
    children,
    innerRef,
    maxHeight,
    stylesheet: customStylesheet
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$2);

  const {
    className
  } = otherProps;
  const maxHeightInPixels = maxHeight ? `${maxHeight}px` : undefined;
  const panelContainerClassName = createCustomClassNames(className, "panel-container");
  const panelContainerInnerClassName = createCustomClassNames(className, "panel-container-inner");
  return /*#__PURE__*/React.createElement(index.Consumer, null, _ref => {
    let {
      resolvedRoles,
      metadata
    } = _ref;
    metadata.colorSchemeId;
    const styles = stylesheet({
      transitionStatus: null,
      anchorPoint: null,
      stylesheet: customStylesheet
    }, resolvedRoles);
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.panelContainer), panelContainerClassName),
      ref: innerRef,
      style: {
        maxHeight: maxHeightInPixels
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.panelContainerInner), panelContainerInnerClassName)
    }, children));
  });
}

PanelContainerPresenter.propTypes = {
  /** A required ref that's used to position the flyout */
  innerRef: PropTypes.func.isRequired,

  /** The panel content */
  children: PropTypes.node,

  /** Max height of the panel */
  maxHeight: PropTypes.number,

  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
PanelContainerPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PanelContainerPresenter",
  "props": {
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "A required ref that's used to position the flyout"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "The panel content"
    },
    "maxHeight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max height of the panel"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};
const _excluded$1 = ["children", "onScroll", "stylesheet"];

function PanelPresenter(_ref) {
  let {
    children,
    onScroll,
    stylesheet: customStylesheet
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  const {
    className
  } = otherProps;
  const panelClassName = createCustomClassNames(className, "panel");
  return /*#__PURE__*/React.createElement(index.Consumer, null, _ref2 => {
    let {
      resolvedRoles
    } = _ref2;
    const styles = stylesheet({
      transitionStatus: null,
      anchorPoint: null,
      stylesheet: customStylesheet
    }, resolvedRoles);
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css(styles.panel), panelClassName),
      onScroll: onScroll
    }, children);
  });
}

PanelPresenter.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func,
  stylesheet: PropTypes.func
};
PanelPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PanelPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
const _excluded = ["openOnHoverDelay", "pointer", "stylesheet"],
      _excluded2 = ["maxHeight", "onScroll", "stylesheet"];
/** @typedef {import("./getCoordinates").Coordinates} Coordinates */

/**
 * @typedef {Object} PanelRendererPayload
 * @property {function(HTMLElement): void} innerRef
 * @property {function(): void} hideFlyout
 * @property {JSX} [content]
 * @property {function(UIEvent): void} [handleScroll]
 * @property {number} [maxHeight]
 */

/**
 * @typedef {Object} State
 * @property {HTMLElement} [actionRef]
 * @property {boolean} open Used to direct the flyout's transition behavior
 * @property {HTMLElement} [panelRef]
 * @property {SVGSVGElement} [pointerRef]
 * @property {HTMLDivElement} [wrapperRef]
 */

class Flyout extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      open: this.props.defaultOpen
    });

    _defineProperty(this, "handleChildMouseEnter", () => {
      if (this.props.openOnHover) {
        this.setOpen(true);
      }
    });

    _defineProperty(this, "handleChildMouseLeave", () => {
      if (this.props.openOnHover) {
        this.setOpen(false);
      }
    });

    _defineProperty(this, "handleChildClick", () => {
      if (!this.isOpenControlled()) {
        this.toggleOpen();
      }
    });

    _defineProperty(this, "handleBodyClick", event => {
      const {
        wrapperRef
      } = this.state;
      const {
        onClickOutside
      } = this.props;
      const flyoutClicked = event.target === wrapperRef || wrapperRef.contains(event.target);
      if (flyoutClicked || !this.isOpen()) return;
      if (onClickOutside) onClickOutside(event);
      if (!this.isOpenControlled()) this.toggleOpen();
    });

    _defineProperty(this, "refAction", actionRef => {
      this.setState({
        actionRef
      });
    });

    _defineProperty(this, "refPointer", pointerRef => {
      this.setState({
        pointerRef
      });
    });

    _defineProperty(this, "refPanel", panelRef => {
      this.setState({
        panelRef
      });
    });

    _defineProperty(this, "refWrapper", wrapperRef => {
      this.setState({
        wrapperRef
      });
    });

    _defineProperty(this, "hideFlyout", () => {
      this.setOpen(false);
    });

    _defineProperty(this, "renderPresenter", transitionStatus => {
      const {
        handleChildMouseEnter,
        handleChildMouseLeave,
        refAction,
        refPointer,
        refWrapper
      } = this;

      const _this$props = this.props,
            {
        openOnHoverDelay,
        pointer,
        stylesheet
      } = _this$props,
            otherProps = _objectWithoutProperties(_this$props, _excluded);

      const {
        className
      } = otherProps;
      const panel = this.renderPanel({
        transitionStatus
      });
      const {
        anchorPoint,
        containerPosition,
        pointerPosition
      } = this.getCoordinates();
      return /*#__PURE__*/React.createElement(HoverBehavior, {
        onMouseEnter: handleChildMouseEnter,
        onMouseLeave: handleChildMouseLeave,
        openOnHoverDelay: openOnHoverDelay
      }, _ref => {
        let {
          onMouseEnter,
          onMouseLeave
        } = _ref;
        return /*#__PURE__*/React.createElement(FlyoutPresenter, {
          anchorPoint: anchorPoint,
          className: className,
          stylesheet: stylesheet,
          containerPosition: containerPosition,
          panel: panel,
          pointer: pointer,
          pointerPosition: pointerPosition,
          refAction: refAction,
          refPointer: refPointer,
          refWrapper: refWrapper,
          transitionStatus: transitionStatus
        }, this.renderChildren(onMouseEnter, onMouseLeave));
      });
    });
  }

  componentDidMount() {
    window.document.body.addEventListener("click", this.handleBodyClick, true);
  }

  componentWillUnmount() {
    window.document.body.removeEventListener("click", this.handleBodyClick, true);
  }
  /**
   * @returns {Coordinates}
   */


  getCoordinates() {
    const {
      alterCoordinates,
      anchorPoint,
      fallbackAnchorPoints
    } = this.props;
    const {
      actionRef,
      panelRef,
      pointerRef
    } = this.state;

    if (!actionRef || !panelRef || !pointerRef || typeof window === "undefined") {
      return DEFAULT_COORDINATES;
    }

    const actionRect = actionRef.getBoundingClientRect();
    const panelRect = panelRef.getBoundingClientRect();
    const pointerRect = pointerRef.getBoundingClientRect();
    const viewportRect = window.document.documentElement.getBoundingClientRect();
    const coordinates = getCoordinates({
      anchorPoint,
      actionRect,
      fallbackAnchorPoints,
      panelRect,
      pointerRect,
      viewportRect
    });

    if (alterCoordinates) {
      const rects = {
        actionRect,
        panelRect,
        pointerRect,
        viewportRect
      };
      return alterCoordinates(coordinates, rects);
    }

    return coordinates;
  }
  /**
   * @param {boolean} open
   */


  setOpen(open) {
    const {
      onClose,
      onOpen
    } = this.props;

    if (open && onOpen) {
      onOpen();
    } else if (!open && onClose) {
      onClose();
    }

    this.setState({
      open
    });
  } // eslint-disable-next-line react/sort-comp


  isOpenControlled() {
    return this.props.open !== undefined;
  }

  isOpen() {
    return this.isOpenControlled() ? this.props.open : this.state.open;
  }

  toggleOpen() {
    this.setOpen(!this.state.open);
  }
  /**
   * @returns {PanelRendererPayload}
   */


  createPanelPayload() {
    const {
      hideFlyout
    } = this;

    const _this$props2 = this.props,
          {
      maxHeight,
      onScroll,
      stylesheet
    } = _this$props2,
          otherProps = _objectWithoutProperties(_this$props2, _excluded2);

    const {
      className
    } = otherProps;
    return {
      hideFlyout,
      maxHeight,
      content: this.renderContent(),
      handleScroll: onScroll,
      innerRef: this.refPanel,
      className,
      stylesheet
    };
  }

  renderContent() {
    const {
      content
    } = this.props;
    const {
      hideFlyout
    } = this;

    if (typeof content === "function") {
      return content({
        hideFlyout
      });
    }

    return content;
  }

  renderPanel(_ref2) {
    let {
      transitionStatus
    } = _ref2;
    const {
      panel
    } = this.props;

    if (typeof panel === "function") {
      return panel(_objectSpread2(_objectSpread2({}, this.createPanelPayload()), {}, {
        transitionStatus
      }));
    }

    return panel;
  }

  renderChildren(onMouseEnter, onMouseLeave) {
    const {
      children
    } = this.props;
    const {
      handleChildClick
    } = this;

    if (typeof children === "function") {
      return children({
        handleClick: handleChildClick
      });
    }

    if (React.Children.count(children) === 1) {
      return /*#__PURE__*/React.cloneElement(children, {
        onClick: combineEventHandlers(handleChildClick, children.props.onClick),
        onMouseEnter,
        onMouseLeave
      });
    }

    return children;
  }

  render() {
    return /*#__PURE__*/React.createElement(ContainerTransition, {
      open: this.isOpen()
    }, this.renderPresenter);
  }

}

_defineProperty(Flyout, "propTypes", {
  /** Manipulate flyout coordinates before rendering */
  alterCoordinates: PropTypes.func,

  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),

  /** Target component to open the flyout. Can be either a node or a render function */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** Content for the flyout. Can be either a node or a render function */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** Default uncontrolled open state */
  defaultOpen: PropTypes.bool,

  /**
   * When the flyout overflows the viewport, it'll attempt to
   * use the given anchor points in order to keep the flyout
   * within the viewport.
   */
  fallbackAnchorPoints: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS)),

  /** Renders a custom flyout panel. Can be either a node or a render function */
  panel: PropTypes.func,

  /** A custom pointer */
  pointer: PropTypes.node,

  /** Max height of the flyout content, in pixels */
  maxHeight: PropTypes.number,

  /** Function called when the flyout is open, and a click event occurs outside the flyout */
  onClickOutside: PropTypes.func,

  /** Function called when the flyout closes */
  onClose: PropTypes.func,

  /** Function called when the flyout opens */
  onOpen: PropTypes.func,

  /** Function called when the flyout panel is scrolled */
  onScroll: PropTypes.func,

  /** When provided, it overrides the flyout's open state */
  open: PropTypes.bool,

  /** Whether flyout should open when the target is hovered over */
  openOnHover: PropTypes.bool,

  /**
   * If openOnHover is true, this prop will determine the delay
   * from when mouseEnter begins until the flyout visually opens
   */
  openOnHoverDelay: PropTypes.number,

  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
});

_defineProperty(Flyout, "defaultProps", {
  anchorPoint: DEFAULT_COORDINATES.anchorPoint,
  defaultOpen: false,
  fallbackAnchorPoints: AVAILABLE_ANCHOR_POINTS,
  openOnHover: false,
  openOnHoverDelay: 500,

  /**
   * @param {PanelRendererPayload} payload
   */
  // eslint-disable-next-line react/no-unstable-nested-components
  panel(_ref3) {
    let {
      innerRef,
      content,
      handleScroll,
      maxHeight,
      className,
      stylesheet
    } = _ref3;
    return /*#__PURE__*/React.createElement(PanelContainerPresenter, {
      innerRef: innerRef,
      maxHeight: maxHeight,
      className: className,
      stylesheet: stylesheet
    }, /*#__PURE__*/React.createElement(PanelPresenter, {
      onScroll: handleScroll,
      className: className,
      stylesheet: stylesheet
    }, content));
  }

});

Flyout.__docgenInfo = {
  "description": "@typedef {Object} State\n@property {HTMLElement} [actionRef]\n@property {boolean} open Used to direct the flyout's transition behavior\n@property {HTMLElement} [panelRef]\n@property {SVGSVGElement} [pointerRef]\n@property {HTMLDivElement} [wrapperRef]",
  "displayName": "Flyout",
  "props": {
    "alterCoordinates": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Manipulate flyout coordinates before rendering"
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.anchorPoint",
        "computed": true
      }
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Target component to open the flyout. Can be either a node or a render function"
    },
    "content": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Content for the flyout. Can be either a node or a render function"
    },
    "defaultOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Default uncontrolled open state",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "fallbackAnchorPoints": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "enum",
          "computed": true,
          "value": "AVAILABLE_ANCHOR_POINTS"
        }
      },
      "required": false,
      "description": "When the flyout overflows the viewport, it'll attempt to\nuse the given anchor points in order to keep the flyout\nwithin the viewport.",
      "defaultValue": {
        "value": "AVAILABLE_ANCHOR_POINTS",
        "computed": true
      }
    },
    "panel": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Renders a custom flyout panel. Can be either a node or a render function",
      "defaultValue": {
        "value": "function(\n    {\n      innerRef,\n      content,\n      handleScroll,\n      maxHeight,\n      className,\n      stylesheet,\n    }\n) {\n  return (\n    <PanelContainerPresenter\n      innerRef={innerRef}\n      maxHeight={maxHeight}\n      className={className}\n      stylesheet={stylesheet}\n    >\n      <PanelPresenter\n        onScroll={handleScroll}\n        className={className}\n        stylesheet={stylesheet}\n      >\n        {content}\n      </PanelPresenter>\n    </PanelContainerPresenter>\n  );\n}",
        "computed": false
      }
    },
    "pointer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A custom pointer"
    },
    "maxHeight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max height of the flyout content, in pixels"
    },
    "onClickOutside": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout is open, and a click event occurs outside the flyout"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout closes"
    },
    "onOpen": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout opens"
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout panel is scrolled"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "When provided, it overrides the flyout's open state"
    },
    "openOnHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether flyout should open when the target is hovered over",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "openOnHoverDelay": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "If openOnHover is true, this prop will determine the delay\nfrom when mouseEnter begins until the flyout visually opens",
      "defaultValue": {
        "value": "500",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

Flyout.Panel = PanelContainerPresenter;

NotificationsFlyout.Image = ImagePresenter;
NotificationsFlyout.Notification = Notification;

export { AVAILABLE_ANCHOR_POINTS, AVAILABLE_TYPES, ImagePresenter as Image, Notification, anchorPoints, NotificationsFlyout as default, types };
